import { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckBox, FerramentasDeDetalhe, SelectComponent } from "../../shered/components";
import { VForm, VTextField, useVForm } from "../../shered/forms";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { LigaService, IListagemLigas, lstStatus } from "../../shered/services/api/liga/LigaService";
import {
    Box, LinearProgress,
    Paper, Tab, Button, Icon,
    Table, TableBody, TableCell,
    TableContainer, TableFooter, TableHead,
    TableRow, Tabs, Typography, TextField,
    FormLabel, tableCellClasses, FormControl,
    Select,
    MenuItem,
    RadioGroup as MuiRadioGroup,
    FormControlLabel,
    Radio, Switch, tabsClasses,
    Card,
    CardContent,
    InputLabel,
    Checkbox as MuiCheckBox,
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import { styled } from '@mui/material/styles';
import { useAuthContext } from "../../shered/contexts";
import { useDebounce } from "../../shered/hooks";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { Scope } from "@unform/core";
import { VInputNumber } from "../../shered/forms/VInputNumber";
import { DisputaService, IDadosConferencia, IDadosCopinha, IDadosCopinhaGrupo, IDadosCopinhaGrupoFranquias, IDadosDivisao, IDadosEscolhas, IDadosEscolhasCalouro, IDadosFranquiaDisputa, IDadosFreeAgency, IDadosLeilao, IDetalheDisputaLiga, ILstDisputaDados } from "../../shered/services/api/disputa/DisputaService";
import { FranquiaService, ILstDrop } from "../../shered/services/api/franquia/FranquiaService";
import { VTextFieldDatas } from "../../shered/forms/VTextFieldDatas";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import { number } from "yup";
import { Loading } from "../../shered/components/loading/Loading";
import { terminoLeilao, UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";
import { DraftService, IDadosSorteio, IDadosSorteioCalouro, IDetalheDraftSorteioPicks } from "../../shered/services/api/draft/DraftService";
import moment from "moment";
import dayjs from "dayjs";



const lstMelhorDe = [
    {
        codigo: 1,
        label: "1",
    },
    {
        codigo: 3,
        label: "3",
    },
    {
        codigo: 5,
        label: "5",
    },
    {
        codigo: 7,
        label: "7",
    }
];

const TipoSorteioFranquias = [
    { codigo: 1, label: 'Sorteio' },
    { codigo: 2, label: 'Manual' },
];

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <> {value === index ?
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {
                    // value === index && (
                    <Box sx={{ p: 3 }}>
                        <Grid>{children}</Grid>
                    </Box>
                    //)
                }
            </div>
            : ""}
        </>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

let exibirTabelasFranquias = true;
let exibirDadosSorteio = true;
let exibirDadosSorteioCalouro = true;
export const DetalheDeDisputa: React.FC = () => {

    const user = CookieService.get("access_user");
    let codLocal = localStorage.getItem("@codigoLiga");
    const [codigoLiga, setCodigoLiga] = useState(codLocal !== null ? UtilidadeService.decrypt(codLocal) : "0");
    //const classes = useStyles();
    const navigate = useNavigate();
    const { debounce } = useDebounce();
    const { formRef, save, saveAndClose, isSaveAndClose } = useVForm();
    const { logout } = useAuthContext();
    const [isLoading, setIsLoading] = useState(false);
    const [openCloseFreeAgency, setOpenCloseFreeAgency] = useState(false);
    const [openCloseDraft, setOpenCloseDraft] = useState(false);
    const [openCloseDraftInicial, setOpenCloseDraftInicial] = useState(false);
    const [labelOpenCloseDA, setLabelOpenCloseDA] = useState("Abrir");
    const [labelOpenCloseDAInicial, setLabelOpenCloseDAInicial] = useState("Abrir");
    const [showImagemFranquia, setShowImagemFranquia] = useState<any>("../../semimagemescudo.png");
    const [openCloseMercado, setOpenCloseMercado] = useState(false);
    const [atualizarConferencia, setAtualizarConferencia] = useState(false);
    const [atualizaCanlendario, setAtualizaCanlendario] = useState(false);
    const [atualizarLeilao, setAtualizarLeilao] = useState(false);
    const [openCloseTrocaPosicao, setOpenCloseTrocaPosicao] = useState(false);

    const [labelOpenCloseME, setLabelOpenCloseME] = useState("Abrir");
    const [labelOpenCloseFA, setLabelOpenCloseFA] = useState("Abrir");
    const [openCloseLeilao, setOpenCloseLeilao] = useState(false);
    const [labelOpenCloseLeilao, setLabelOpenCloseLeilao] = useState("Abrir");
    const [liberarEncerrar, setLiberarEncerrar] = useState(false);
    const [labelLiberarEncerrar, setLabelLiberarEncerrar] = useState("Liberar");
    const [labelOpenCloseTrocaPosicao, setLabelOpenCloseTrocaPosicao] = useState("Abrir");

    const [value, setValue] = useState(0);
    const [valueTabRodada, setValueTabRodada] = useState(0);
    const [qtdRodadas, setQtdRodadas] = useState(0);

    const [searchParams, SetSearchParams] = useSearchParams();
    const [edicao, setEdicao] = useState(false);
    const [removeLoading, setRemoveLoading] = useState(false);
    const [semRelogioCalouro, setSemRelogioCalouro] = useState(false);
    const [semRelogioInicial, setSemRelogioInicial] = useState(false);
    const [desativarPrimeiraRodada, setDesativarPrimeiraRodada] = useState(false);
    const [desativarPrimeiraRodadaCalouro, setDesativarPrimeiraRodadaCalouro] = useState(false);
    const [sorteioRealizado, setSorteioRealizado] = useState(false);
    const [sorteioFinalizado, setSorteioFinalizado] = useState(false);
    const [sorteioCalouroRealizado, setSorteioCalouroRealizado] = useState(false);
    const [sorteioCalouroFinalizado, setSorteioCalouroFinalizado] = useState(false);
    const [dataUltimoSorteio, setDataUltimoSorteio] = useState<any>();
    const [dataUltimoSorteioCalouro, setDataUltimoSorteioCalouro] = useState<any>();
    const [rowsSorteioPicks, setRowsSorteioPicks] = useState<IDetalheDraftSorteioPicks[]>([]);
    const [dadosConfiguracao, setDadosConfiguracao] = useState<IDetalheDisputaLiga>();

    const [lstEscolhas, setLstEscolhas] = useState<IDadosEscolhas[]>([]);

    const [lstEscolhasCalouro, setLstEscolhasCalouro] = useState<IDadosEscolhasCalouro[]>([]);
    const [rowsSorteioPicksCalouro, setRowsSorteiosPicksCalouro] = useState<IDetalheDraftSorteioPicks[]>([]);

    //#region


    const [data_Abertura_FA, setData_Abertura_FA] = useState("");
    const [data_Abertura_ME, setData_Abertura_ME] = useState("");
    const [data_Abertura_DA, setData_Abertura_DA] = useState("");
    const [data_Encerramento_Calouro, setData_Encerramento_Calouro] = useState("");
    const [data_Abertura_Calouro, setData_Abertura_Calouro] = useState("");

    const [data_Abertura_TP, setData_Abertura_TP] = useState("");

    const [data_Encerramento_FA, setData_Encerramento_FA] = useState("");
    const [data_Encerramento_ME, setData_Encerramento_ME] = useState("");
    const [data_Encerramento_DA, setData_Encerramento_DA] = useState("");
    const [data_Encerramento_TP, setData_Encerramento_TP] = useState("");
    const [data_Encerramento_DAInicial, setData_Encerramento_DAInicial] = useState("");


    const [data_Abertura_LE, setData_Abertura_LE] = useState("");
    const [data_Encerramento_LE, setData_Encerramento_LE] = useState("");
    const [horaViradaLeilao, setHoraViradaLeilao] = useState("");
    const [periodoUtilInicialCalouro, setPeriodoUtilInicialCalouro] = useState("");
    const [periodoUtilFinalCalouro, setPeriodoUtilFinalCalouro] = useState("");

    const [periodoUtilInicialInicial, setPeriodoUtilInicialInicial] = useState("");
    const [periodoUtilFinalInicial, setPeriodoUtilFinalInicial] = useState("");



    const [tempoDuracaoLeilao, setTempoDuracaoLeilao] = useState(1);
    const [tempoDuracaoCalouro, setTempoDuracaoCalouro] = useState(0);
    const [tempoDuracaoInicial, setTempoDuracaoInicial] = useState(0);


    const [data_Inicio_EL, setData_Inicio_EL] = useState<string>();
    const [data_Encerramento_EL, setData_Encerramento_EL] = useState<string>();


    const pagina = useMemo(() => {
        return Number(searchParams.get("pagina") || "1");
    }, [searchParams]);


    //#region variaveis franquias (eval)
    const [lstConferenciasRows, setLstConferenciasRows] = useState<IDadosConferencia[]>([]);

    const [divisao1FranquiasRows, setDivisao1FranquiasRows] = useState<IDadosFranquiaDisputa[]>([]);
    const [divisao2FranquiasRows, setDivisao2FranquiasRows] = useState<IDadosFranquiaDisputa[]>([]);
    const [divisao3FranquiasRows, setDivisao3FranquiasRows] = useState<IDadosFranquiaDisputa[]>([]);
    const [divisao4FranquiasRows, setDivisao4FranquiasRows] = useState<IDadosFranquiaDisputa[]>([]);
    const [divisao5FranquiasRows, setDivisao5FranquiasRows] = useState<IDadosFranquiaDisputa[]>([]);
    const [divisao6FranquiasRows, setDivisao6FranquiasRows] = useState<IDadosFranquiaDisputa[]>([]);
    const [divisao7FranquiasRows, setDivisao7FranquiasRows] = useState<IDadosFranquiaDisputa[]>([]);
    const [divisao8FranquiasRows, setDivisao8FranquiasRows] = useState<IDadosFranquiaDisputa[]>([]);

    const [grupo1Rows, setGrupo1Rows] = useState<IDadosCopinhaGrupo>();
    const [grupo2Rows, setGrupo2Rows] = useState<IDadosCopinhaGrupo>();
    const [grupo3Rows, setGrupo3Rows] = useState<IDadosCopinhaGrupo>();
    const [grupo4Rows, setGrupo4Rows] = useState<IDadosCopinhaGrupo>();
    const [grupo5Rows, setGrupo5Rows] = useState<IDadosCopinhaGrupo>();
    const [grupo6Rows, setGrupo6Rows] = useState<IDadosCopinhaGrupo>();
    const [grupo7Rows, setGrupo7Rows] = useState<IDadosCopinhaGrupo>();
    const [grupo8Rows, setGrupo8Rows] = useState<IDadosCopinhaGrupo>();

    const [franquias1Rows, setFranquias1Rows] = useState<IDadosCopinhaGrupoFranquias[]>([]);
    const [franquias2Rows, setFranquias2Rows] = useState<IDadosCopinhaGrupoFranquias[]>([]);
    const [franquias3Rows, setFranquias3Rows] = useState<IDadosCopinhaGrupoFranquias[]>([]);
    const [franquias4Rows, setFranquias4Rows] = useState<IDadosCopinhaGrupoFranquias[]>([]);
    const [franquias5Rows, setFranquias5Rows] = useState<IDadosCopinhaGrupoFranquias[]>([]);
    const [franquias6Rows, setFranquias6Rows] = useState<IDadosCopinhaGrupoFranquias[]>([]);
    const [franquias7Rows, setFranquias7Rows] = useState<IDadosCopinhaGrupoFranquias[]>([]);
    const [franquias8Rows, setFranquias8Rows] = useState<IDadosCopinhaGrupoFranquias[]>([]);

    // const [lstFranquiasConf1Rows, setLstFranquiasConf1Rows] = useState<IDadosFranquiaDisputa[]>([]);
    // const [lstFranquiasConf2Rows, setLstFranquiasConf2Rows] = useState<IDadosFranquiaDisputa[]>([]);

    const [divisaoRowsAux, setDivisaoRowsAux] = useState<number[]>([]);

    const [conf2_divisao4, setDivisao8] = useState("");
    const [conf2_divisao3, setDivisao7] = useState("");
    const [conf2_divisao2, setDivisao6] = useState("");
    const [conf2_divisao1, setDivisao5] = useState("");
    const [conf1_divisao1, setDivisao1] = useState("");
    const [conf1_divisao2, setDivisao2] = useState("");
    const [conf1_divisao3, setDivisao3] = useState("");
    const [conf1_divisao4, setDivisao4] = useState("");
    const [conferencia1, setConferencia1] = useState("");
    const [conferencia2, setConferencia2] = useState("");


    const [codigo_Conferencia1, setCodigo_Conferencia1] = useState(0);
    const [codigo_Conferencia2, setCodigo_Conferencia2] = useState(0);
    const [codigo_conf1_divisao1, setCodigo_conf1_divisao1] = useState(0);
    const [codigo_conf1_divisao2, setCodigo_conf1_divisao2] = useState(0);
    const [codigo_conf1_divisao3, setCodigo_conf1_divisao3] = useState(0);
    const [codigo_conf1_divisao4, setCodigo_conf1_divisao4] = useState(0);
    const [codigo_conf2_divisao1, setCodigo_conf2_divisao1] = useState(0);
    const [codigo_conf2_divisao2, setCodigo_conf2_divisao2] = useState(0);
    const [codigo_conf2_divisao3, setCodigo_conf2_divisao3] = useState(0);
    const [codigo_conf2_divisao4, setCodigo_conf2_divisao4] = useState(0);



    const [dropFranquia10, setDropFranquia10] = useState(0);
    const [dropFranquia11, setDropFranquia11] = useState(0);
    const [dropFranquia12, setDropFranquia12] = useState(0);
    const [dropFranquia13, setDropFranquia13] = useState(0);
    const [dropFranquia14, setDropFranquia14] = useState(0);
    const [dropFranquia15, setDropFranquia15] = useState(0);
    const [dropFranquia16, setDropFranquia16] = useState(0);

    const [dropFranquia50, setDropFranquia50] = useState(0);
    const [dropFranquia51, setDropFranquia51] = useState(0);
    const [dropFranquia52, setDropFranquia52] = useState(0);
    const [dropFranquia53, setDropFranquia53] = useState(0);
    const [dropFranquia54, setDropFranquia54] = useState(0);
    const [dropFranquia55, setDropFranquia55] = useState(0);
    const [dropFranquia56, setDropFranquia56] = useState(0);

    const [dropFranquia20, setDropFranquia20] = useState(0);
    const [dropFranquia21, setDropFranquia21] = useState(0);
    const [dropFranquia22, setDropFranquia22] = useState(0);
    const [dropFranquia23, setDropFranquia23] = useState(0);
    const [dropFranquia24, setDropFranquia24] = useState(0);
    const [dropFranquia25, setDropFranquia25] = useState(0);
    const [dropFranquia26, setDropFranquia26] = useState(0);

    const [dropFranquia30, setDropFranquia30] = useState(0);
    const [dropFranquia31, setDropFranquia31] = useState(0);
    const [dropFranquia32, setDropFranquia32] = useState(0);
    const [dropFranquia33, setDropFranquia33] = useState(0);
    const [dropFranquia34, setDropFranquia34] = useState(0);
    const [dropFranquia35, setDropFranquia35] = useState(0);
    const [dropFranquia36, setDropFranquia36] = useState(0);

    const [dropFranquia40, setDropFranquia40] = useState(0);
    const [dropFranquia41, setDropFranquia41] = useState(0);
    const [dropFranquia42, setDropFranquia42] = useState(0);
    const [dropFranquia43, setDropFranquia43] = useState(0);
    const [dropFranquia44, setDropFranquia44] = useState(0);
    const [dropFranquia45, setDropFranquia45] = useState(0);
    const [dropFranquia46, setDropFranquia46] = useState(0);

    const [dropFranquia60, setDropFranquia60] = useState(0);
    const [dropFranquia61, setDropFranquia61] = useState(0);
    const [dropFranquia62, setDropFranquia62] = useState(0);
    const [dropFranquia63, setDropFranquia63] = useState(0);
    const [dropFranquia64, setDropFranquia64] = useState(0);
    const [dropFranquia65, setDropFranquia65] = useState(0);
    const [dropFranquia66, setDropFranquia66] = useState(0);

    const [dropFranquia70, setDropFranquia70] = useState(0);
    const [dropFranquia71, setDropFranquia71] = useState(0);
    const [dropFranquia72, setDropFranquia72] = useState(0);
    const [dropFranquia73, setDropFranquia73] = useState(0);
    const [dropFranquia74, setDropFranquia74] = useState(0);
    const [dropFranquia75, setDropFranquia75] = useState(0);
    const [dropFranquia76, setDropFranquia76] = useState(0);

    const [dropFranquia80, setDropFranquia80] = useState(0);
    const [dropFranquia81, setDropFranquia81] = useState(0);
    const [dropFranquia82, setDropFranquia82] = useState(0);
    const [dropFranquia83, setDropFranquia83] = useState(0);
    const [dropFranquia84, setDropFranquia84] = useState(0);
    const [dropFranquia85, setDropFranquia85] = useState(0);
    const [dropFranquia86, setDropFranquia86] = useState(0);

    const [dropFranquia2, setDropFranquia2] = useState(0);
    const [dropFranquia3, setDropFranquia3] = useState(0);
    const [dropFranquia4, setDropFranquia4] = useState(0);
    const [dropFranquia5, setDropFranquia5] = useState(0);
    const [dropFranquia6, setDropFranquia6] = useState(0);
    const [dropFranquia7, setDropFranquia7] = useState(0);
    const [dropFranquia8, setDropFranquia8] = useState(0);

    const [franquiaSelecionada1, setFranquiaSelecionada1] = useState(0);
    const [franquiaSelecionada2, setFranquiaSelecionada2] = useState(0);
    const [franquiaSelecionada3, setFranquiaSelecionada3] = useState(0);
    const [franquiaSelecionada4, setFranquiaSelecionada4] = useState(0);
    const [franquiaSelecionada5, setFranquiaSelecionada5] = useState(0);
    const [franquiaSelecionada6, setFranquiaSelecionada6] = useState(0);
    const [franquiaSelecionada7, setFranquiaSelecionada7] = useState(0);
    const [franquiaSelecionada8, setFranquiaSelecionada8] = useState(0);
    const [franquiaSelecionada9, setFranquiaSelecionada9] = useState(0);
    const [franquiaSelecionada10, setFranquiaSelecionada10] = useState(0);
    const [franquiaSelecionada11, setFranquiaSelecionada11] = useState(0);
    const [franquiaSelecionada12, setFranquiaSelecionada12] = useState(0);
    const [franquiaSelecionada13, setFranquiaSelecionada13] = useState(0);
    const [franquiaSelecionada14, setFranquiaSelecionada14] = useState(0);
    const [franquiaSelecionada15, setFranquiaSelecionada15] = useState(0);
    const [franquiaSelecionada16, setFranquiaSelecionada16] = useState(0);
    const [franquiaSelecionada17, setFranquiaSelecionada17] = useState(0);
    const [franquiaSelecionada18, setFranquiaSelecionada18] = useState(0);
    const [franquiaSelecionada19, setFranquiaSelecionada19] = useState(0);
    const [franquiaSelecionada20, setFranquiaSelecionada20] = useState(0);
    const [franquiaSelecionada21, setFranquiaSelecionada21] = useState(0);
    const [franquiaSelecionada22, setFranquiaSelecionada22] = useState(0);
    const [franquiaSelecionada23, setFranquiaSelecionada23] = useState(0);
    const [franquiaSelecionada24, setFranquiaSelecionada24] = useState(0);
    const [franquiaSelecionada25, setFranquiaSelecionada25] = useState(0);
    const [franquiaSelecionada26, setFranquiaSelecionada26] = useState(0);
    const [franquiaSelecionada27, setFranquiaSelecionada27] = useState(0);
    const [franquiaSelecionada28, setFranquiaSelecionada28] = useState(0);
    const [franquiaSelecionada29, setFranquiaSelecionada29] = useState(0);
    const [franquiaSelecionada30, setFranquiaSelecionada30] = useState(0);
    const [franquiaSelecionada31, setFranquiaSelecionada31] = useState(0);
    const [franquiaSelecionada32, setFranquiaSelecionada32] = useState(0);


    const [franquiaSelecionadaCalouro1, setFranquiaSelecionadaCalouro1] = useState(0);
    const [franquiaSelecionadaCalouro2, setFranquiaSelecionadaCalouro2] = useState(0);
    const [franquiaSelecionadaCalouro3, setFranquiaSelecionadaCalouro3] = useState(0);
    const [franquiaSelecionadaCalouro4, setFranquiaSelecionadaCalouro4] = useState(0);
    const [franquiaSelecionadaCalouro5, setFranquiaSelecionadaCalouro5] = useState(0);
    const [franquiaSelecionadaCalouro6, setFranquiaSelecionadaCalouro6] = useState(0);
    const [franquiaSelecionadaCalouro7, setFranquiaSelecionadaCalouro7] = useState(0);
    const [franquiaSelecionadaCalouro8, setFranquiaSelecionadaCalouro8] = useState(0);
    const [franquiaSelecionadaCalouro9, setFranquiaSelecionadaCalouro9] = useState(0);
    const [franquiaSelecionadaCalouro10, setFranquiaSelecionadaCalouro10] = useState(0);
    const [franquiaSelecionadaCalouro11, setFranquiaSelecionadaCalouro11] = useState(0);
    const [franquiaSelecionadaCalouro12, setFranquiaSelecionadaCalouro12] = useState(0);
    const [franquiaSelecionadaCalouro13, setFranquiaSelecionadaCalouro13] = useState(0);
    const [franquiaSelecionadaCalouro14, setFranquiaSelecionadaCalouro14] = useState(0);
    const [franquiaSelecionadaCalouro15, setFranquiaSelecionadaCalouro15] = useState(0);
    const [franquiaSelecionadaCalouro16, setFranquiaSelecionadaCalouro16] = useState(0);
    const [franquiaSelecionadaCalouro17, setFranquiaSelecionadaCalouro17] = useState(0);
    const [franquiaSelecionadaCalouro18, setFranquiaSelecionadaCalouro18] = useState(0);
    const [franquiaSelecionadaCalouro19, setFranquiaSelecionadaCalouro19] = useState(0);
    const [franquiaSelecionadaCalouro20, setFranquiaSelecionadaCalouro20] = useState(0);
    const [franquiaSelecionadaCalouro21, setFranquiaSelecionadaCalouro21] = useState(0);
    const [franquiaSelecionadaCalouro22, setFranquiaSelecionadaCalouro22] = useState(0);
    const [franquiaSelecionadaCalouro23, setFranquiaSelecionadaCalouro23] = useState(0);
    const [franquiaSelecionadaCalouro24, setFranquiaSelecionadaCalouro24] = useState(0);
    const [franquiaSelecionadaCalouro25, setFranquiaSelecionadaCalouro25] = useState(0);
    const [franquiaSelecionadaCalouro26, setFranquiaSelecionadaCalouro26] = useState(0);
    const [franquiaSelecionadaCalouro27, setFranquiaSelecionadaCalouro27] = useState(0);
    const [franquiaSelecionadaCalouro28, setFranquiaSelecionadaCalouro28] = useState(0);
    const [franquiaSelecionadaCalouro29, setFranquiaSelecionadaCalouro29] = useState(0);
    const [franquiaSelecionadaCalouro30, setFranquiaSelecionadaCalouro30] = useState(0);
    const [franquiaSelecionadaCalouro31, setFranquiaSelecionadaCalouro31] = useState(0);
    const [franquiaSelecionadaCalouro32, setFranquiaSelecionadaCalouro32] = useState(0);


    //#endregion

    const [lstFranquia, setLstFranquia] = useState<ILstDrop[]>([]);
    const [lstFranquiaAux, setLstFranquiaAux] = useState<ILstDrop[]>([]);
    const [lstDivisao, setLstDivisao] = useState<IDadosDivisao[]>([]);
    const [lstDropDivisao, setLstDropDivisao] = useState<ILstDrop[]>([]);

    const [dadosLiga, setDadosLiga] = useState<IListagemLigas>();
    const [nomeLiga, setNomeLiga] = useState("");
    const [logoImage, setLogoImage] = useState("");
    const [qtdFranquias, setQtdFranquias] = useState(0);
    const [codigoTemporada, setCodigoTemporada] = useState(0);
    const [fraquiasCriadas, setFraquiasCriadas] = useState(true);
    const [temporadaIniciada, setTemporadaIniciada] = useState(false);
    const [usuarioComissario, setUsuarioComissario] = useState(false);
    const [primeiraTemporada, setPrimeiraTemporada] = useState(false);

    const [dataSorteioCopinha, setDataSorteioCopinha] = useState("");
    const [copinhaSorteada, setCopinhaSorteada] = useState(false);

    const [divisaoDupla, setDivisaoDupla] = useState(false);
    const [divisaoTripla, setDivisaoTripla] = useState(false);
    const [divisaoQuadrupla, setDivisaoQuadrupla] = useState(false);

    const [franquia24, setFranquia24] = useState(false);
    const [franquia30, setFranquia30] = useState(false);

    const [liberarEdicao, setLiberarEdicao] = useState(false);
    const [capMinimo, setCapMinimo] = useState(false);
    const [capMaximo, setCapMaximo] = useState(false);
    const [minPosicao, setMinPosicao] = useState(false);
    const [maxJogadores, setMaxJogadores] = useState(false);
    const [minJogadores, setMinJogadores] = useState(false);

    const [atualizar_Franquia, setAtualizar_Franquia] = useState(false);
    const [redirecionar, setRedirecionar] = useState("");
    //const [listaFranquiasAux, setListaFranquiasAux] = useState<ILstDrop[]>([]);
    const [lstFranquiaSalvar, setLstFranquiaSalvar] = useState<IDadosFranquiaDisputa[]>([]);
    const [data_Sorteio_Franquia, setData_Sorteio_Franquia] = useState<Date>();
    const [lstQuantidadeRodadas, setLstQuantidadeRodadas] = useState<any[]>([]);
    const [lstTodasFranquias, setLstTodasFranquias] = useState<IDadosFranquiaDisputa[]>([]);
    const [atualizar_Franquia_Escolha, setAtualizar_Franquia_Escolha] = useState(false);

    const [exibirDados, setExibirDados] = useState(false);
    const [exibirDadosCalouro, setExibirDadosCalouro] = useState(false);
    const [allStarGameLiga, setAllStarGameLiga] = useState(false);
    const [maisConferencia, setMaisConferencia] = useState(false);
    const [maisDivisao, setMaisDivisao] = useState(false);
    const [playIn, setPlayIn] = useState(false);

    const [quantidadesJogos, setQuantidadesJogos] = useState(0);
    const [melhorDe, setMelhorDe] = useState(0);
    const [valoresTimeSorteio, setValoresTimeSorteio] = useState<any[]>([]);
    const [qtdRodadasEscolidas, setQtdRodadasEscolidas] = useState<number[]>([]);
    const [showRodadasTabs, setShowRodadasTabs] = useState(false);
    const [escolha_Espelhada_Draft_Calouro, setEscolha_Espelhada_Draft_Calouro] = useState(false);
    const [espelhoAtualizado, setEspelhoAtualizado] = useState(false);
    const [tempoZerado, setTempoZerado] = useState(false);
    const [tempoZeradoCalouro, setTempoZeradoCalouro] = useState(false);
    const [dadosFreeAgency, setDadosFreeAgency] = useState<IDadosFreeAgency>();
    const [dadosLeilao, setDadosLeilao] = useState<IDadosLeilao>();

    const [tipoEdit, setTipoEdit] = useState(false);
    const [tipo, setTipo] = useState(0);
    const [primeiraRodada, setPrimeiraRodada] = useState(0);

    const [lstPosicaoFranquia, setLstPosicaoFranquia] = useState({
        codigoFranquia: 0,
        posicao: 0
    });
    const [showSorteio, setShowSorteio] = useState(true);
    const [showSorteioCalouro, setShowSorteioCalouro] = useState(true);
    const [primeiraRodadaCalouro, setPrimeiraRodadaCalouro] = useState(0);
    const [atualizar_Franquia_Escolha_Calouro, setAtualizar_Franquia_Escolha_Calouro] = useState(false);
    const [atualizar_Situacao_Calouro, setAtualizar_Situacao_Calouro] = useState(false);
    const [atualizar_Situacao_Inicial, setAtualizar_Situacao_Inicial] = useState(false);

    const [atualizarFreeAgency, setAtualizarFreeAgency] = useState(false);

    const [dadosCopinha, setDadosCopinha] = useState<IDadosCopinha>();
    const qtdFranquiasDupla = [12, 16, 20, 24, 28];
    const qtdFranquiasTripla = [30];
    //const [sorteioCopinhaRealizado, setSorteioCopinhaRealizado] = useState(false);
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    //#endregion

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: UtilidadeService.isMobile() ? 12 : "auto",
            padding: "5px "
        },
        [`&.${tableCellClasses.footer}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        }
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td': {
            border: 0,
        },
        '&:last-child th': {
            border: 0,
            padding: "12px 8px "
        },
    }));

    const handleDelete = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            LigaService.deleteById(id)
                .then((result) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Registro excluido com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar("/disputas");

                }).catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });

                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                });
        }
    }

    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const handleChangeTabsRodadas = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabRodada(newValue);
    };

    //#region Aba Tabela

    const verificarFranquiasDropEscolhida = (e: any, index: number, divisao: number, conferencia: number) => {

        setAtualizar_Franquia(true);

        if (e.target.value != 0 && (
            divisao1FranquiasRows.find(f => f.codigo_Franquia === e.target.value)
            || divisao2FranquiasRows.find(f => f.codigo_Franquia === e.target.value)
            || divisao3FranquiasRows.find(f => f.codigo_Franquia === e.target.value)
            || divisao4FranquiasRows.find(f => f.codigo_Franquia === e.target.value)
            || divisao5FranquiasRows.find(f => f.codigo_Franquia === e.target.value)
            || divisao6FranquiasRows.find(f => f.codigo_Franquia === e.target.value)
            || divisao7FranquiasRows.find(f => f.codigo_Franquia === e.target.value)
            || divisao8FranquiasRows.find(f => f.codigo_Franquia === e.target.value)
        )) {

            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Franquia já selecionada",
                display: "none",
                titulo: "Atenção"
            });
            setTimeout(() => { setShowModalMensagem(false); }, 3500);
            return;
        }

        if (divisao === 1) {
            if (conferencia === 1) {
                divisao1FranquiasRows[index]["codigo_Franquia"] = e.target.value
                setDivisao1FranquiasRows(divisao1FranquiasRows);
                setDivisaoRowsAux([...divisaoRowsAux, e.target.value]);
                eval(`setDropFranquia1${index}(Number(e.target.value))`);

            }
            else {
                divisao5FranquiasRows[index]["codigo_Franquia"] = e.target.value
                setDivisao5FranquiasRows(divisao5FranquiasRows);
                setDivisaoRowsAux([...divisaoRowsAux, e.target.value])
                eval(`setDropFranquia5${index}(Number(e.target.value))`);
            }
        }
        else if (divisao === 2) {

            if (conferencia === 1) {
                divisao2FranquiasRows[index]["codigo_Franquia"] = e.target.value
                setDivisao2FranquiasRows(divisao2FranquiasRows);
                setDivisaoRowsAux([...divisaoRowsAux, e.target.value]);
                eval(`setDropFranquia2${index}(Number(e.target.value))`);
            }
            else {
                divisao6FranquiasRows[index]["codigo_Franquia"] = e.target.value
                setDivisao6FranquiasRows(divisao6FranquiasRows);
                setDivisaoRowsAux([...divisaoRowsAux, e.target.value]);
                eval(`setDropFranquia6${index}(Number(e.target.value))`);
            }
        }
        else if (divisao === 3) {
            if (conferencia === 1) {
                divisao3FranquiasRows[index]["codigo_Franquia"] = e.target.value
                setDivisao3FranquiasRows(divisao3FranquiasRows);
                setDivisaoRowsAux([...divisaoRowsAux, e.target.value])
                eval(`setDropFranquia3${index}(e.target.value)`);

            }
            else {
                divisao7FranquiasRows[index]["codigo_Franquia"] = e.target.value
                setDivisao7FranquiasRows(divisao7FranquiasRows);
                setDivisaoRowsAux([...divisaoRowsAux, e.target.value]);
                eval(`setDropFranquia7${index}(Number(e.target.value))`);
            }
        }
        else {

            if (conferencia === 1) {
                divisao4FranquiasRows[index]["codigo_Franquia"] = e.target.value
                setDivisao4FranquiasRows(divisao4FranquiasRows);
                setDivisaoRowsAux([...divisaoRowsAux, e.target.value]);
                eval(`setDropFranquia4${index}(Number(e.target.value))`);
            }
            else {
                divisao8FranquiasRows[index]["codigo_Franquia"] = e.target.value
                setDivisao8FranquiasRows(divisao8FranquiasRows);
                setDivisaoRowsAux([...divisaoRowsAux, e.target.value]);
                eval(`setDropFranquia8${index}(Number(e.target.value))`);
            }
        }
        setShowModalMensagem(false);
    }

    //#endregion

    useEffect(() => {
        setIsLoading(true);
        setRemoveLoading(false);
        if (codigoLiga === "" || codigoLiga === null || codigoLiga === "0") {
            setShowModalMensagem(true);
            setRemoveLoading(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "warning",
                mensagem: "Favor selecionar uma liga!",
                display: "none",
                titulo: "Atenção"
            });
            setRedirecionar("/dashboard");
            return;
        }

        const fetchData = async () => {
            // setRemoveLoading(false);
            await DisputaService.getEscolhasPorCodigoLiga(Number(codigoLiga))
                .then((result) => {
                    setLstEscolhas(result.dado);
                    setDesativarPrimeiraRodada(result.dado.length > 0);
                    setExibirDados(result.dado.length > 0);
                })
                .catch((errors) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    //console.log(errors);
                    if (errors.response != undefined && errors.response.data.statusHTTP === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    else {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Não foi possível carregar os dados de escolha inicial! Favor entrar em contato com a TI ",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                });


            await DisputaService.getEscolhasCalouroPorCodigoLiga(Number(codigoLiga))
                .then((result) => {
                    setLstEscolhasCalouro(result.dado.sort((a, b) => (a.posicao_Final !== null ? a.posicao_Final : a.codigo_Franquia)
                        > (b.posicao_Final !== null ? b.posicao_Final : b.codigo_Franquia) ? 1 : -1));
                    setDesativarPrimeiraRodadaCalouro(result.dado.length > 0);
                    setExibirDadosCalouro(result.dado.length > 0);
                })
                .catch((errors) => {
                    setIsLoading(false);
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    //console.log(errors);
                    if (errors.response != undefined && errors.response.data.statusHTTP === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    else {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Não foi possível carregar os dados de escolha inicial! Favor entrar em contato com a TI ",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                });

            await LigaService.getDadosLigaPeloCodigo(Number(codigoLiga))
                .then((result) => {
                    const liga = result.dado;

                    // let dtI = "";
                    // if (liga.data_Sorteio_Copinha !== undefined) {
                    //     dtI = dayjs(liga.data_Sorteio_Copinha, "YYYY-MM-DD HH:mm").format();
                    // }
                    setDadosLiga(liga);
                    setNomeLiga(liga.nome);
                    setLogoImage(liga.caminho_Logo);
                    setQtdFranquias(liga.quantidade_Franquia);
                    setTemporadaIniciada(liga.status === 3);
                    setCodigoTemporada(liga.codigo_Temporada);
                    setPrimeiraTemporada(liga.primeira_Temporada);
                    //alert(dtI);
                    // setDataSorteioCopinha(dtI);
                    setCopinhaSorteada(usuarioComissario || user.administrador ? liga.copinha_Sorteada === undefined ? true : liga.copinha_Sorteada : false);
                    handleCarregarDadosSorteioCopinha(liga.codigo_Temporada);

                    if (liga.primeira_Temporada) {
                        CarregarDadosSorteioInicial();
                        CarregarDadosSorteioCalouro();
                    }
                    setUsuarioComissario(liga.comissario_Usuario);
                    if (liga.comissario_Usuario === false) {
                        setValue(0);
                        // let cod = codigoLiga === undefined ? "0" : codigoLiga.toString()
                        // let cryptLiga = UtilidadeService.crypt(cod);
                        // navigate(`/usuario/liga/${cryptLiga}`);
                        // return;
                    }
                    if (liga.status === 3) {
                        setValue(3);
                    }

                    if (qtdFranquiasDupla.includes(liga.quantidade_Franquia)) {
                        setDivisaoDupla(true);
                        setDivisaoTripla(false);
                        setDivisaoQuadrupla(false);
                    }
                    else if (qtdFranquiasTripla.includes(liga.quantidade_Franquia)) {
                        setDivisaoDupla(true);
                        setDivisaoTripla(true);
                        setDivisaoQuadrupla(false);
                    }
                    else {
                        setDivisaoDupla(true);
                        setDivisaoTripla(true);
                        setDivisaoQuadrupla(true);
                    }

                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }

                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                });

            await FranquiaService.getByIdLiga(Number(codigoLiga))
                .then((result) => {
                    let lstFranquia = result.dado.map((f, i) => ({ codigo: f.codigo, label: f.nome === null ? `Franquia ${i + 1} ` : f.nome }));
                    setLstFranquiaAux(lstFranquia);
                    setLstFranquia(lstFranquia);

                }).catch((errors) => {
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    if (errors.response.data.statusHTTP === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                    else {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                });

            await DisputaService.getAllPorCodigoLiga(Number(codigoLiga))
                .then((result) => {
                    let lstDivisao: IDadosDivisao[] = [];
                    const disp = result.dado;                  
                    setDadosConfiguracao(result.dado);
                    // setIsLoading(false);
                    // setRemoveLoading(true);
                    setPlayIn(disp.configuracao_Calendario_Liga.play_In);
                    setMelhorDe(disp.configuracao_Calendario_Liga.quantidade_Rodadas_Play_Offs);
                    setQtdRodadas(disp.configuracao_Calendario_Liga.quantidade_Rodadas);
                    setTipoEdit(false);

                    if (disp.free_Agency !== null && disp.free_Agency !== undefined) {
                        setDadosFreeAgency(disp.free_Agency);
                        setOpenCloseFreeAgency(disp.free_Agency?.situacao === true ? true : false);
                        setLabelOpenCloseFA(disp.free_Agency?.situacao ? "Fechar" : "Abrir");
                        if (disp.free_Agency !== undefined && disp.free_Agency.data_Abertura !== null && disp.free_Agency.data_Abertura !== undefined) {
                            formRef.current?.setFieldValue("free_Agency.data_Abertura", dayjs(disp.free_Agency.data_Abertura).format("YYYY-MM-DD HH:mm"));
                            setData_Abertura_FA(dayjs(disp.free_Agency.data_Abertura).format("YYYY-MM-DD HH:mm"));
                        }
                        if (disp.free_Agency?.data_Encerramento !== null && disp.free_Agency?.data_Encerramento !== undefined) {
                            formRef.current?.setFieldValue("free_Agency.data_Encerramento", dayjs(disp.free_Agency.data_Encerramento).format("YYYY-MM-DD HH:mm"));
                            setData_Encerramento_FA(dayjs(disp.free_Agency.data_Encerramento).format("YYYY-MM-DD HH:mm"));
                        }
                    }
                    setOpenCloseLeilao(disp.leilao?.situacao === true ? true : false);
                    setLabelOpenCloseLeilao(disp.leilao?.situacao ? "Fechar" : "Abrir");
                    if (disp.leilao !== null) {
                        setDadosLeilao(disp.leilao);
                        setTempoDuracaoLeilao(disp.leilao?.tempo_Duracao ?? 1);
                        setHoraViradaLeilao(disp.leilao?.hora_Virada ?? "");
                        formRef.current?.setFieldValue("leilao", disp.leilao);
                        if (disp.leilao !== null && disp.leilao !== undefined && disp.leilao.data_Abertura !== null && disp.leilao.data_Abertura !== undefined) {
                            formRef.current?.setFieldValue("leilao.data_Abertura", dayjs(disp.leilao.data_Abertura).format("YYYY-MM-DD HH:mm"));
                            setData_Abertura_LE(dayjs(disp.leilao.data_Abertura).format("YYYY-MM-DD HH:mm"));
                        }
                        if (disp.leilao !== null && disp.leilao !== undefined && disp.leilao?.data_Encerramento !== null && disp.free_Agency?.data_Encerramento !== undefined) {
                            formRef.current?.setFieldValue("leilao.data_Encerramento", dayjs(disp.leilao.data_Encerramento).format("YYYY-MM-DD HH:mm"));
                            setData_Encerramento_LE(dayjs(disp.leilao.data_Encerramento).format("YYYY-MM-DD HH:mm"));
                        }
                    }
                    setOpenCloseDraft(disp.configuracao_Liga.situacao_Calouro === true ? true : false);
                    setLabelOpenCloseDA(disp.configuracao_Liga?.situacao_Calouro ? "Fechar" : "Abrir");
                    if (disp.configuracao_Liga !== null && disp.configuracao_Liga !== undefined && disp.configuracao_Liga.data_Abertura_Calouro !== null && disp.configuracao_Liga.data_Abertura_Calouro !== undefined) {
                        setData_Abertura_Calouro(dayjs(disp.configuracao_Liga.data_Abertura_Calouro).format("YYYY-MM-DD HH:mm"));
                        setTempoDuracaoCalouro(disp.configuracao_Liga.tempo_Escolha_Calouro ?? 0);
                        setSemRelogioCalouro(disp.configuracao_Liga.sem_Relogio_Calouro);
                        setPeriodoUtilFinalCalouro(disp.configuracao_Liga.periodo_Util_Final_Calouro ?? "")
                        setPeriodoUtilInicialCalouro(disp.configuracao_Liga.periodo_Util_Inicial_Calouro ?? "")

                    }
                    if (disp.configuracao_Liga !== null && disp.configuracao_Liga !== undefined && disp.configuracao_Liga?.data_Encerramento_Calouro !== null && disp.configuracao_Liga?.data_Encerramento_Calouro !== undefined) {
                        setData_Encerramento_Calouro(dayjs(disp.configuracao_Liga.data_Encerramento_Calouro).format("YYYY-MM-DD HH:mm"));
                    }
                    if (disp.configuracao_Liga !== null && disp.configuracao_Liga !== undefined && disp.configuracao_Liga.data_Abertura_Inicial !== null && disp.configuracao_Liga.data_Abertura_Inicial !== undefined) {
                        setData_Abertura_DA(dayjs(disp.configuracao_Liga.data_Abertura_Inicial).format("YYYY-MM-DD HH:mm"));
                        setTempoDuracaoInicial(disp.configuracao_Liga.tempo_Escolha_Inicial ?? 0);
                        setPeriodoUtilFinalInicial(disp.configuracao_Liga.periodo_Util_Final_Inicial ?? "");
                        setPeriodoUtilInicialInicial(disp.configuracao_Liga.periodo_Util_Inicio_Inicial ?? "");


                    }
                    if (disp.configuracao_Liga !== null && disp.configuracao_Liga !== undefined && disp.configuracao_Liga?.data_Encerramento_Inicial !== null && disp.configuracao_Liga?.data_Encerramento_Inicial !== undefined) {
                        setData_Encerramento_DA(dayjs(disp.configuracao_Liga.data_Encerramento_Inicial).format("YYYY-MM-DD HH:mm"));
                    }
                    if (disp.configuracao_Liga !== null && disp.configuracao_Liga !== undefined && disp.configuracao_Liga.data_Abertura_Mercado !== null && disp.configuracao_Liga.data_Abertura_Mercado !== undefined) {
                        setData_Abertura_ME(dayjs(disp.configuracao_Liga.data_Abertura_Mercado).format("YYYY-MM-DD HH:mm"));
                    }
                    if (disp.configuracao_Liga !== null && disp.configuracao_Liga !== undefined && disp.configuracao_Liga?.data_Encerramento_Mercado !== null && disp.configuracao_Liga?.data_Encerramento_Mercado !== undefined) {
                        setData_Encerramento_ME(dayjs(disp.configuracao_Liga.data_Encerramento_Mercado).format("YYYY-MM-DD HH:mm"));
                    }
                    if (disp.configuracao_Liga !== null && disp.configuracao_Liga !== undefined && disp.configuracao_Liga.data_Abertura_Troca_Posicao !== null && disp.configuracao_Liga.data_Abertura_Troca_Posicao !== undefined) {
                        setData_Abertura_ME(dayjs(disp.configuracao_Liga.data_Abertura_Troca_Posicao).format("YYYY-MM-DD HH:mm"));
                    }
                    if (disp.configuracao_Liga !== null && disp.configuracao_Liga !== undefined && disp.configuracao_Liga?.data_Encerramento_Troca_Posicao !== null && disp.configuracao_Liga?.data_Encerramento_Troca_Posicao !== undefined) {
                        setData_Encerramento_ME(dayjs(disp.configuracao_Liga.data_Encerramento_Troca_Posicao).format("YYYY-MM-DD HH:mm"));
                    }

                    setOpenCloseMercado(disp.configuracao_Liga.situacao_Mercado === true ? true : false);
                    setLabelOpenCloseME(disp.configuracao_Liga?.situacao_Mercado ? "Fechar" : "Abrir");

                    setOpenCloseTrocaPosicao(disp.configuracao_Liga.situacao_Troca_Posicao === true ? true : false);
                    setLabelOpenCloseME(disp.configuracao_Liga?.situacao_Troca_Posicao ? "Fechar" : "Abrir");

                    setMaisDivisao(disp.configuracao_Calendario_Liga.enfrentar_Mais_Vezes_Divisao);
                    setMaisConferencia(disp.configuracao_Calendario_Liga.enfrentar_Mais_Vezes_Conferencia);

                    setOpenCloseDraftInicial(disp.configuracao_Liga.situacao_Inicial === true ? true : false);
                    setLabelOpenCloseDAInicial(disp.configuracao_Liga?.situacao_Inicial ? "Fechar" : "Abrir");
                    setSemRelogioInicial(disp.configuracao_Liga.sem_Relogio_Inicial);
                    if (disp.liberacoes_Liga !== null) {
                        exibirTabelasFranquias = tipo === 1 && disp.liberacoes_Liga.data_Sorteio_Franquia !== null || (disp.liberacoes_Liga.data_Sorteio_Franquia !== undefined && new Date(disp.liberacoes_Liga.data_Sorteio_Franquia) <= new Date()) ? true : false;
                        setTipo(disp.liberacoes_Liga.data_Sorteio_Franquia !== null ? 1 : divisao1FranquiasRows.length > 0 ? 2 : 0);
                        setCapMinimo(disp.liberacoes_Liga?.baixo_Min_Cap);
                        setCapMaximo(disp.liberacoes_Liga?.estouro_Cap)
                        setMinJogadores(disp.liberacoes_Liga?.baixo_Min_Jog)
                        setMaxJogadores(disp.liberacoes_Liga?.estouro_Max_Jog)
                        setMinPosicao(disp.liberacoes_Liga?.baixo_Min_Pos)
                        setLiberarEncerrar(disp.liberacoes_Liga?.situacao);
                        setLabelLiberarEncerrar(disp.liberacoes_Liga?.situacao ? "Encerrar" : "Liberar");
                        if (disp.liberacoes_Liga !== null && disp.liberacoes_Liga !== undefined
                            && disp.liberacoes_Liga?.data_Inicio !== null
                            && disp.liberacoes_Liga?.data_Inicio !== undefined) {
                            setData_Inicio_EL(dayjs(disp.liberacoes_Liga.data_Inicio).format("YYYY-MM-DD HH:mm"));
                        }
                        if (disp.liberacoes_Liga !== null && disp.liberacoes_Liga !== undefined
                            && disp.liberacoes_Liga?.data_Fim !== null
                            && disp.liberacoes_Liga?.data_Fim !== undefined) {
                            setData_Encerramento_EL(dayjs(disp.liberacoes_Liga.data_Fim).format("YYYY-MM-DD HH:mm"));
                        }

                        //setShowSorteioCalouro(disp.liberacoes_Liga.data_Sorteio_Franquia_Draft_Calouro !== null);
                        setEspelhoAtualizado(false);

                    }
                    if (disp.conferencia.length === 2) {
                        setLstConferenciasRows(disp.conferencia);
                        setLiberarEdicao(true);
                        disp.conferencia.map((f, c) => {
                            if (c === 0) {
                                setConferencia1(f.nome);
                                setCodigo_Conferencia1(Number(f.codigo));
                                setEdicao(true);

                            } else {
                                setConferencia2(f.nome);
                                setCodigo_Conferencia2(Number(f.codigo));
                                setEdicao(true);
                            }
                            if (f.divisao.length > 0) {
                                setLstTodasFranquias(result.dado.franquia);
                                setFraquiasCriadas(result.dado.franquia.length === qtdFranquias && result.dado.franquia.filter(n => n.codigo_Conferencia === f.codigo).length > 0);
                                f.divisao.map((d, i) => {
                                    let lstFranquia = result.dado.franquia.filter(m => m.codigo_Divisao === d.codigo && m.codigo_Conferencia === f.codigo)
                                    let codFranquia = 0;
                                    lstDivisao.push(d);
                                    if (c === 0) {

                                        setEdicao(true);
                                        if (i === 0) {
                                            setDivisao1(d.nome);
                                            setCodigo_conf1_divisao1(Number(d.codigo));
                                            setDivisao1FranquiasRows(lstFranquia);
                                            lstFranquia.map((k, i) => {
                                                codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
                                                eval(`setDropFranquia1${i}(codFranquia)`);
                                            });
                                        }
                                        else if (i === 1) {
                                            setDivisao2(d.nome);
                                            setCodigo_conf1_divisao2(Number(d.codigo));
                                            setDivisao2FranquiasRows(lstFranquia);
                                            lstFranquia.map((k, i) => {
                                                codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
                                                eval(`setDropFranquia2${i}(codFranquia)`);
                                            });

                                        }
                                        else if (i === 2) {
                                            setDivisao3(d.nome);
                                            setCodigo_conf1_divisao3(Number(d.codigo));
                                            setDivisao3FranquiasRows(lstFranquia);

                                            lstFranquia.map((k, i) => {
                                                codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
                                                eval(`setDropFranquia3${i}(codFranquia)`);
                                            });
                                        }
                                        else {
                                            setDivisao4(d.nome);
                                            setCodigo_conf1_divisao4(Number(d.codigo));
                                            setDivisao4FranquiasRows(lstFranquia);
                                            lstFranquia.map((k, i) => {
                                                codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
                                                eval(`setDropFranquia4${i}(codFranquia)`);
                                            });
                                        }
                                    }
                                    else {
                                        setEdicao(true);
                                        if (i === 0) {
                                            setDivisao5(d.nome);
                                            setCodigo_conf2_divisao1(Number(d.codigo));
                                            setDivisao5FranquiasRows(lstFranquia);
                                            lstFranquia.map((k, i) => {
                                                codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
                                                eval(`setDropFranquia5${i}(codFranquia)`);
                                            });
                                        }
                                        else if (i === 1) {
                                            setDivisao6(d.nome);
                                            setCodigo_conf2_divisao2(Number(d.codigo));
                                            setDivisao6FranquiasRows(lstFranquia);
                                            lstFranquia.map((k, i) => {
                                                codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
                                                eval(`setDropFranquia6${i}(codFranquia)`);
                                            });
                                        }
                                        else if (i === 2) {
                                            setDivisao7(d.nome);
                                            setCodigo_conf2_divisao3(Number(d.codigo));
                                            setDivisao7FranquiasRows(lstFranquia);
                                            lstFranquia.map((k, i) => {
                                                codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
                                                eval(`setDropFranquia7${i}(codFranquia)`);
                                            });
                                        }
                                        else {
                                            setDivisao8(d.nome);
                                            setCodigo_conf2_divisao4(Number(d.codigo));
                                            setDivisao8FranquiasRows(lstFranquia);
                                            lstFranquia.map((k, i) => {
                                                codFranquia = lstFranquia[i].codigo_Franquia ?? 0;
                                                eval(`setDropFranquia8${i}(codFranquia)`);
                                            });
                                        }
                                    }
                                });
                            }
                        });

                        setLstDropDivisao(lstDivisao.map((f, i) => ({ codigo: i, label: f.nome })));
                        setLstDivisao(lstDivisao);

                        // if (disp.calendario.length > 0) {
                        //     var auxValoresTimeSorteio: any[] = [];
                        //     setShowRodadasTabs(true);
                        //     let rds = disp.calendario.map(m => m.rodada);
                        //     let unique = rds.filter((el, i, arr) => arr.indexOf(el) == i);

                        //     for (let i = 1; i <= unique.length; i++) {
                        //         qtdRodadasEscolidas.push(i);
                        //         disp.calendario.filter(y => y.rodada === i).forEach(f => {
                        //             auxValoresTimeSorteio.push({
                        //                 rodada: i,
                        //                 mandante: f.codigo_Franquia_Mandante,
                        //                 visitante: f.codigo_Franquia_Visitante
                        //             });
                        //         });
                        //     }
                        //     setValoresTimeSorteio(auxValoresTimeSorteio);
                        // }
                        // else {
                        //     calcularQtdRodadas();
                        // }

                        if (disp.franquias_Picks_Rodada_Inicial.length > 0) {

                            // if (disp.franquias_Picks_Rodada_Inicial.filter(f => f.codigo_Franquia !== null).length > 0) {                                
                            //     setPrimeiraRodada(disp.liberacoes_Liga.data_Sorteio_Franquia_Draft_Inicial !== null ? 1 : 2);
                            // }
                            disp.franquias_Picks_Rodada_Inicial.forEach(f => {
                                if (f.codigo_Franquia !== null) {
                                    eval(`setFranquiaSelecionada${f.escolha_Inicial}(${f.codigo_Franquia !== undefined ? f.codigo_Franquia : 0})`);
                                }
                            });
                        }
                        if (disp.franquias_Picks.length > 0) {
                            // if (disp.franquias_Picks.filter(f => f.codigo_Franquia !== null).length > 0) {
                            //     setPrimeiraRodadaCalouro(disp.liberacoes_Liga.data_Sorteio_Franquia_Draft_Calouro !== null ? 1 : 2);
                            // }
                            disp.franquias_Picks.forEach((f, i) => {
                                if (f.posicao_Final !== null) {
                                    eval(`setFranquiaSelecionadaCalouro${f.posicao_Final === null ? i + 1 : f.posicao_Final}(${f.codigo_Franquia !== undefined ? f.codigo_Franquia : 0})`);
                                }
                            });
                        }
                    }
                    formRef.current?.setData(disp);
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    setRemoveLoading(true);

                    //console.log(errors);
                    if (errors.response != undefined && errors.response.data.statusHTTP === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                    else {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Não foi possível carregar os dados de disputa! Favor entrar em contato com a TI ",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar(`/usuario/liga/${codLocal}`);
                        return;
                    }
                });


            setIsLoading(false);
            setRemoveLoading(true);
        }
        fetchData();
    }, [codigoLiga, liberarEdicao, espelhoAtualizado]);

    const CarregarDadosSorteioInicial = async () => {

        await DraftService.getDraftSorteioInicialById(Number(codigoLiga))
            .then((result) => {
                setShowModalMensagem(false);
                let resultado = result.dado;
                setDataUltimoSorteio(resultado.data_Proximo_Sorteio);
                setRowsSorteioPicks(resultado.informacoes_Loteria);
                exibirDadosSorteio = resultado.sorteio_Realizado;
                setShowSorteio(resultado.sorteio_Realizado);
                setSorteioRealizado(resultado.sorteio_Realizado);
                setSorteioFinalizado(resultado.sorteio_Finalizado);
                setPrimeiraRodada(resultado.sorteio_Realizado ? 1 : 2);
                if ((!tempoZerado || !resultado.sorteio_Finalizado) && resultado.sorteio_Realizado) {
                    UseCountdown(resultado.data_Proximo_Sorteio, resultado.sorteio_Realizado);
                    setTempoZerado(false);
                }

            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response !== undefined) {
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: "Não foi possível carregar os dados do sorteio! Favor tentar novamente. Caso o problema persista, entrar em contato com a TI",
                    display: "none",
                    titulo: "Atenção"
                });

            });
    }

    const CarregarDadosSorteioCalouro = async () => {
        await DisputaService.getDraftSorteioCalouroById(Number(codigoLiga))
            .then((result) => {
                setShowModalMensagem(false);
                let resultado = result.dado;
                setEscolha_Espelhada_Draft_Calouro(resultado.espelhada);
                setDataUltimoSorteioCalouro(resultado.data_Proximo_Sorteio);
                setRowsSorteiosPicksCalouro(resultado.informacoes_Loteria);
                exibirDadosSorteioCalouro = resultado.sorteio_Realizado;
                setShowSorteioCalouro(resultado.sorteio_Realizado);
                setSorteioCalouroRealizado(resultado.sorteio_Realizado);
                setSorteioCalouroFinalizado(resultado.sorteio_Finalizado);
                setPrimeiraRodadaCalouro(resultado.sorteio_Realizado ? 1 : 2);

                if ((!tempoZeradoCalouro || !resultado.sorteio_Finalizado) && resultado.sorteio_Realizado) {
                    UseCountdownCalouro(resultado.data_Proximo_Sorteio, resultado.sorteio_Realizado);
                    setTempoZeradoCalouro(false);

                }
            })
            .catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                //console.log(errors);
                if (errors.response != undefined && errors.response.data.statusHTTP === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                else {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Não foi possível carregar os dados de escolha inicial! Favor entrar em contato com a TI ",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
            });
    }

    const verificarCamposObrigatorios = (dados: ILstDisputaDados) => {

        if (tipo === 1 && dados.liberacoes_Liga.data_Sorteio_Franquia === undefined) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Campo data fim  é obrigatório!",
                display: "none",
                titulo: "Atenção"
            });
            setIsLoading(false);
            setRemoveLoading(true);
            return false;
        }

        if (openCloseLeilao) {
            if (dados.leilao.data_Abertura === undefined) {
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "info",
                    mensagem: "Campo data de abertura do leilão é obrigatória!",
                    display: "none",
                    titulo: "Atenção"
                });
                setIsLoading(false);
                setRemoveLoading(true);
                return false;
            }
            if (dados.leilao.tempo_Duracao <= 0) {
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "info",
                    mensagem: "Campo tempo de duração do leilão é obrigatório!",
                    display: "none",
                    titulo: "Atenção"
                });
                setIsLoading(false);
                setRemoveLoading(true);
                return false;
            }

            if (dados.leilao.hora_Virada === undefined || dados.leilao.hora_Virada === "") {
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "info",
                    mensagem: "Campo hora da virada do leilão é obrigatória!",
                    display: "none",
                    titulo: "Atenção"
                });
                setIsLoading(false);
                setRemoveLoading(true);
                return false;
            }

            if (dados.leilao.data_Encerramento === undefined) {
                setShowModalMensagem(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "info",
                    mensagem: "Campo data de encerramento do leilão é obrigatória!",
                    display: "none",
                    titulo: "Atenção"
                });
                setIsLoading(false);
                setRemoveLoading(true);
                return false;
            }
        }

        return true;
    }

    const handleSave = async (dados: ILstDisputaDados, { reset }: any) => {
        setLstFranquiaSalvar([]);
        setIsLoading(true);
        setRemoveLoading(false);
        var free: any = null;
        if (atualizarFreeAgency) {
            free = {
                data_Abertura: dayjs(data_Abertura_FA).format("YYYY-MM-DDTHH:MM:ss"),
                data_Encerramento: dayjs(data_Encerramento_FA).format("YYYY-MM-DDTHH:MM:ss"),
                situacao: openCloseFreeAgency //dados.free_Agency.situacao
            }
        }

        var leilao: any = null;
        if (atualizarLeilao) {                
            leilao = {
                data_Abertura:  dayjs(data_Abertura_LE).format("YYYY-MM-DDTHH:MM:ss"), // dadosLeilao.data_Abertura,
                data_Encerramento: dayjs(data_Encerramento_LE).format("YYYY-MM-DDTHH:MM:ss"),
                hora_Virada: horaViradaLeilao, //  dadosLeilao.hora_Virada,
                tempo_Duracao: tempoDuracaoLeilao, //dadosLeilao.tempo_Duracao,
                situacao: openCloseLeilao
            }
        }

        carregarListaFranquias();
        const dadosSalvar: IDetalheDisputaLiga = {
            codigo_Liga: Number(codigoLiga),
            conferencia: [
                {
                    nome: conferencia1,
                    codigo: codigo_Conferencia1,
                    divisao: qtdFranquiasDupla.includes(qtdFranquias) ? [{
                        nome: conf1_divisao1,
                        codigo: codigo_conf1_divisao1,
                    },
                    {
                        nome: conf1_divisao2,
                        codigo: codigo_conf1_divisao2,
                    }] :
                        qtdFranquiasTripla.includes(qtdFranquias) ? [{
                            nome: conf1_divisao1,
                            codigo: codigo_conf1_divisao1,
                        },
                        {
                            nome: conf1_divisao2,
                            codigo: codigo_conf1_divisao2,
                        },
                        {
                            nome: conf1_divisao3,
                            codigo: codigo_conf1_divisao3,
                        }] :
                            [{
                                nome: conf1_divisao1,
                                codigo: codigo_conf1_divisao1,
                            },
                            {
                                nome: conf1_divisao2,
                                codigo: codigo_conf1_divisao2,
                            },
                            {
                                nome: conf1_divisao3,
                                codigo: codigo_conf1_divisao3,
                            },
                            {
                                nome: conf1_divisao4,
                                codigo: codigo_conf1_divisao4,
                            }]
                },
                {
                    nome: conferencia2,
                    codigo: codigo_Conferencia2,
                    divisao: qtdFranquiasDupla.includes(qtdFranquias) ? [{
                        nome: conf2_divisao1,
                        codigo: codigo_conf2_divisao1,
                    },
                    {
                        nome: conf2_divisao2,
                        codigo: codigo_conf2_divisao2,
                    }] :
                        qtdFranquiasTripla.includes(qtdFranquias) ? [{
                            nome: conf2_divisao1,
                            codigo: codigo_conf2_divisao1,
                        },
                        {
                            nome: conf2_divisao2,
                            codigo: codigo_conf2_divisao2,
                        },
                        {
                            nome: conf2_divisao3,
                            codigo: codigo_conf2_divisao3,
                        }
                        ] :
                            [{
                                nome: conf2_divisao1,
                                codigo: codigo_conf2_divisao1,
                            },
                            {
                                nome: conf2_divisao2,
                                codigo: codigo_conf2_divisao2,
                            },
                            {
                                nome: conf2_divisao3,
                                codigo: codigo_conf2_divisao3,
                            },
                            {
                                nome: conf2_divisao4,
                                codigo: codigo_conf2_divisao4,
                            }]
                }
            ],
            codUsuCriacao: user.codUsuario,
            codUsuModificacao: user.codUsuario,
            atualizar_Conferencia: atualizarConferencia,
            free_Agency: free,
            leilao: leilao,
            atualizar_Leilao: atualizarLeilao,

            configuracao_Liga: {
                data_Abertura_Mercado: data_Abertura_ME !== undefined && data_Abertura_ME !== "" ? dayjs(data_Abertura_ME).format("YYYY-MM-DDTHH:MM:ss") ?? null : null,
                data_Encerramento_Mercado: data_Encerramento_ME !== undefined && data_Encerramento_ME !== "" ? dayjs(data_Encerramento_ME).format("YYYY-MM-DDTHH:MM:ss") ?? null : null,
                situacao_Mercado: openCloseMercado,
                data_Abertura_Calouro: data_Abertura_Calouro !== undefined && data_Abertura_Calouro !== "" ? dayjs(data_Abertura_Calouro).format("YYYY-MM-DDTHH:MM:ss") ?? null : null,
                data_Encerramento_Calouro: data_Encerramento_Calouro !== undefined && data_Encerramento_Calouro !== "" ? dayjs(data_Encerramento_Calouro).format("YYYY-MM-DDTHH:MM:ss") ?? null : null,
                situacao_Calouro: openCloseDraft,
                sem_Relogio_Calouro: semRelogioCalouro,
                periodo_Util_Final_Calouro: periodoUtilFinalCalouro ?? "",
                periodo_Util_Inicial_Calouro: periodoUtilInicialCalouro ?? "",
                tempo_Escolha_Calouro: tempoDuracaoCalouro ?? 0,

                data_Abertura_Inicial: data_Abertura_DA !== undefined && data_Abertura_DA !== "" && data_Abertura_DA !== "" ? dayjs(data_Abertura_DA).format("YYYY-MM-DDTHH:MM:ss") ?? null : null,
                data_Encerramento_Inicial: data_Encerramento_DA !== undefined && data_Encerramento_DA !== "" && data_Encerramento_DA !== "" ? dayjs(data_Encerramento_DA).format("YYYY-MM-DDTHH:MM:ss") ?? null : null,
                situacao_Inicial: openCloseDraftInicial,
                sem_Relogio_Inicial: semRelogioInicial,
                periodo_Util_Final_Inicial: periodoUtilFinalInicial ?? "",
                periodo_Util_Inicio_Inicial: periodoUtilInicialInicial ?? "",
                tempo_Escolha_Inicial: tempoDuracaoInicial ?? 24,

                data_Abertura_Troca_Posicao: data_Abertura_TP !== undefined && data_Abertura_TP !== "" ? dayjs(data_Abertura_TP).format("YYYY-MM-DDTHH:MM:ss") ?? null : null,
                data_Encerramento_Troca_Posicao: data_Encerramento_TP !== undefined && data_Encerramento_TP !== "" ? dayjs(data_Encerramento_TP).format("YYYY-MM-DDTHH:MM:ss") ?? null : null,
                situacao_Troca_Posicao: openCloseTrocaPosicao,
            },

            franquia: lstFranquiaSalvar.map(m => ({
                codigo_Divisao: lstDivisao.find(f => f.nome === m.nome_Divisao)?.codigo || 0,
                codigo_Franquia: Number(m.codigo_Franquia),
            })),
            liberacoes_Liga: {
                ...dados.liberacoes_Liga,
                //data_Inicio: dados.liberacoes_Liga.data_Inicio === undefined ? new Date() : dados.liberacoes_Liga.data_Inicio, --Versão antiga(Gabriel)
                //data_Fim: dados.liberacoes_Liga.data_Fim === undefined ? new Date() : dados.liberacoes_Liga.data_Fim, --Versão antiga(Gabriel)
                data_Inicio: data_Inicio_EL !== undefined && data_Inicio_EL !== ""  ? dayjs(data_Inicio_EL).format("YYYY-MM-DDTHH:MM:ss") : null,
                data_Fim: data_Encerramento_EL !== undefined  && data_Encerramento_EL !== "" ? dayjs(data_Encerramento_EL).format("YYYY-MM-DDTHH:MM:ss") : null,
                situacao: liberarEncerrar,//dados.liberacoes_Liga.situacao
                data_Sorteio_Franquia: tipo === 1 ? dados.liberacoes_Liga.data_Sorteio_Franquia : undefined
            },
            atualizar_Franquia: atualizar_Franquia,
            configuracao_Calendario_Liga: {
                ...dados.configuracao_Calendario_Liga,
                all_Star_Game_Liga: false, //dados.configuracao_Calendario_Liga?.all_Star_Game_Liga,
                enfrentar_Mais_Vezes_Conferencia: dados.configuracao_Calendario_Liga?.enfrentar_Mais_Vezes_Conferencia,
                enfrentar_Mais_Vezes_Divisao: dados.configuracao_Calendario_Liga?.enfrentar_Mais_Vezes_Divisao,
                play_In: dados.configuracao_Calendario_Liga?.play_In,
                quantidade_Rodadas_Play_Offs: melhorDe, //dados.configuracao_Calendario_Liga?.quantidade_Rodadas_Play_Offs,
                quantidade_Rodadas: qtdRodadas //dados.configuracao_Calendario_Liga?.quantidade_Rodadas,
            },

            atualizar_Calendario: atualizaCanlendario,
            calendario: valoresTimeSorteio.length > 0 ? valoresTimeSorteio.map(m => ({
                rodada: m.rodada,
                codigo_Franquia_Mandante: m.mandante,
                codigo_Franquia_Visitante: m.visitante,
                empate: false,
                vencedor_Mandante: false,
                vencedor_Visitante: false,
                status_Jogo: false,
                rodada_Atual: false,
                copinha: false
            })) : [],


            franquias_Picks_Rodada_Inicial: lstEscolhas.length > 0 && lstEscolhas.every(f => f.codigo_Franquia !== null) ? lstEscolhas : [],
            franquias_Picks: lstEscolhasCalouro.length > 0 && lstEscolhasCalouro.every(f => f.posicao_Final !== null) ? lstEscolhasCalouro : [],
            atualizar_franquias_Picks_Rodada_Inicial: atualizar_Franquia_Escolha,
            atualizar_franquias_Picks: atualizar_Franquia_Escolha_Calouro,
            atualizar_Situacao_Calouro: atualizar_Situacao_Calouro,
            atualizar_Situacao_Inicial: atualizar_Situacao_Inicial,

        }
        if (edicao !== true) {
            DisputaService.Create(dadosSalvar)
                .then((result) => {
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Disputa salva com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar("0");
                })
                .catch((errors) => {
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "error",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        logout();
                        setRedirecionar("0");
                        return;
                    }
                    if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: errors.response.data.mensagem,
                            display: "none",
                            titulo: "Atenção"
                        });
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível cadastrar os dados de disputa! Favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                });
        }
        else {
            //#region
            // if (primeiraTemporada && primeiraRodada > 0 && lstEscolhas.filter(f => Number(f.codigo_Franquia) > 0).length < lstFranquia.length) {
            //     setRemoveLoading(true);
            //     setShowModalMensagem(true);
            //     setDadosModal({
            //         acao: true,
            //         label: "",
            //         tipo: "info",
            //         mensagem: "Favor selecionar a ordem de todas as Franquias!",
            //         display: "none",
            //         titulo: "Atenção"
            //     });
            //     return;
            // }

            DisputaService.updateById(dadosSalvar)
                .then((result) => {
                    //console.log(result);
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Disputa atualizada com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });
                })
                .catch((errors) => {
                    setIsLoading(false);
                    setRemoveLoading(true);
                    setShowModalMensagem(true);
                    if (errors.response !== undefined) {
                        if (errors.response.status === 401) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "error",
                                mensagem: "Sessão expirada!",
                                display: "none",
                                titulo: "Atenção"
                            });
                            logout();
                            setRedirecionar("0");
                            return;
                        }
                        if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                            setDadosModal({
                                acao: true,
                                label: "",
                                tipo: "info",
                                mensagem: errors.response.data.mensagem,
                                display: "none",
                                titulo: "Atenção"
                            });
                            return;
                        }
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: "Não foi possível atualizar os dados da disputa! Favor entrar em contato com a TI.",
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                });
        }
    }

    const carregarListaFranquias = () => {
        let a = divisao1FranquiasRows.length > 0 ? divisao1FranquiasRows.map(m => lstFranquiaSalvar.push(m)) : [];
        a = divisao2FranquiasRows.length > 0 ? divisao2FranquiasRows.map(m => lstFranquiaSalvar.push(m)) : [];
        a = divisao3FranquiasRows.length > 0 ? divisao3FranquiasRows.map(m => lstFranquiaSalvar.push(m)) : [];
        a = divisao4FranquiasRows.length > 0 ? divisao4FranquiasRows.map(m => lstFranquiaSalvar.push(m)) : [];
        a = divisao5FranquiasRows.length > 0 ? divisao5FranquiasRows.map(m => lstFranquiaSalvar.push(m)) : [];
        a = divisao6FranquiasRows.length > 0 ? divisao6FranquiasRows.map(m => lstFranquiaSalvar.push(m)) : [];
        a = divisao7FranquiasRows.length > 0 ? divisao7FranquiasRows.map(m => lstFranquiaSalvar.push(m)) : [];
        a = divisao8FranquiasRows.length > 0 ? divisao8FranquiasRows.map(m => lstFranquiaSalvar.push(m)) : [];
    }

    const carregarDadosFranquia = (conf: string, div: string, lista: IDadosFranquiaDisputa[]) => {
        let qtdeFranquiasPorDivisao = qtdFranquias / lstDivisao.length;
        let lstAux = lista;
        for (let f = 1; f <= qtdeFranquiasPorDivisao; f++) {
            lstAux.push({
                nome_Conferencia: conf,
                nome_Divisao: div,
                nome_Franquia: "",
                codigo_Franquia: 0
            });
        }
        return lstAux;
    }

    const criarGruposDivisao = async (conferencias: IDadosConferencia[]) => {
        setTipoEdit(false);
        conferencias.map((conf, i) => {
            conf.divisao.map((div, index) => {
                if (i === 0) {
                    if (index === 0) {
                        if (divisao1FranquiasRows.length <= 0) {
                            setDivisao1FranquiasRows(carregarDadosFranquia(conf.nome, div.nome, divisao1FranquiasRows));
                        }
                    }
                    else if (index === 1) {
                        if (divisao2FranquiasRows.length <= 0) {
                            setDivisao2FranquiasRows(carregarDadosFranquia(conf.nome, div.nome, divisao2FranquiasRows));
                        }
                    }
                    else if (index === 2) {
                        if (divisao3FranquiasRows.length <= 0) {
                            setDivisao3FranquiasRows(carregarDadosFranquia(conf.nome, div.nome, divisao3FranquiasRows));
                        }
                    }
                    else {
                        if (divisao4FranquiasRows.length <= 0) {
                            setDivisao4FranquiasRows(carregarDadosFranquia(conf.nome, div.nome, divisao4FranquiasRows));
                        }
                    }
                }
                if (i === 1) {
                    if (index === 0) {
                        if (divisao5FranquiasRows.length <= 0) {
                            setDivisao5FranquiasRows(carregarDadosFranquia(conf.nome, div.nome, divisao5FranquiasRows));
                        }

                    }
                    else if (index === 1) {
                        if (divisao6FranquiasRows.length <= 0) {
                            setDivisao6FranquiasRows(carregarDadosFranquia(conf.nome, div.nome, divisao6FranquiasRows));
                        }
                    }
                    else if (index === 2) {
                        if (divisao7FranquiasRows.length <= 0) {
                            setDivisao7FranquiasRows(carregarDadosFranquia(conf.nome, div.nome, divisao7FranquiasRows));
                        }
                    }
                    else {
                        if (divisao8FranquiasRows.length <= 0) {
                            setDivisao8FranquiasRows(carregarDadosFranquia(conf.nome, div.nome, divisao8FranquiasRows));
                        }
                    }
                }
            })
        });
    }

    let listaFranquiasAux: ILstDrop[] = [];
    const carregarDadosFranquiaSorteio = (conf: string, div: string, lista: IDadosFranquiaDisputa[], index: number) => {
        let qtdeFranquiasPorDivisao = qtdFranquias / lstDivisao.length;
        let lstAux = lista;

        for (let f = 1; f <= qtdeFranquiasPorDivisao; f++) {
            let item = listaFranquiasAux[Math.floor(Math.random() * listaFranquiasAux.length)];
            eval(`setDropFranquia${index}${f - 1}(item.codigo)`);
            listaFranquiasAux = listaFranquiasAux.filter(f => f.codigo !== item.codigo);
            lstAux.push({
                nome_Conferencia: conf,
                nome_Divisao: div,
                nome_Franquia: item.label,
                codigo_Franquia: item.codigo
            });
        }
        return lstAux;
    }

    const sortearGruposDivisao = async (conferencias: IDadosConferencia[]) => {
        listaFranquiasAux = lstFranquia;
        setLstFranquiaSalvar([]);
        setTipoEdit(false);
        conferencias.map((conf, i) => {
            conf.divisao.map((div, index) => {
                if (i === 0) {
                    if (index === 0) {
                        if (divisao1FranquiasRows.length <= 0) {
                            setDivisao1FranquiasRows(carregarDadosFranquiaSorteio(conf.nome, div.nome, divisao1FranquiasRows, 1));
                            divisao1FranquiasRows.map(m => lstFranquiaSalvar.push(m));
                        }
                    }
                    else if (index === 1) {
                        if (divisao2FranquiasRows.length <= 0) {
                            setDivisao2FranquiasRows(carregarDadosFranquiaSorteio(conf.nome, div.nome, divisao2FranquiasRows, 2));
                            divisao2FranquiasRows.map(m => lstFranquiaSalvar.push(m));
                        }
                    }
                    else if (index === 2) {
                        if (divisao3FranquiasRows.length <= 0) {
                            setDivisao3FranquiasRows(carregarDadosFranquiaSorteio(conf.nome, div.nome, divisao3FranquiasRows, 3));
                            divisao3FranquiasRows.map(m => lstFranquiaSalvar.push(m));
                        }
                    }
                    else {
                        if (divisao4FranquiasRows.length <= 0) {
                            setDivisao4FranquiasRows(carregarDadosFranquiaSorteio(conf.nome, div.nome, divisao4FranquiasRows, 4));
                            divisao4FranquiasRows.map(m => lstFranquiaSalvar.push(m));
                        }
                    }
                }
                if (i === 1) {
                    if (index === 0) {
                        if (divisao5FranquiasRows.length <= 0) {
                            setDivisao5FranquiasRows(carregarDadosFranquiaSorteio(conf.nome, div.nome, divisao5FranquiasRows, 5));
                            divisao5FranquiasRows.map(m => lstFranquiaSalvar.push(m));
                        }
                    }
                    else if (index === 1) {
                        if (divisao6FranquiasRows.length <= 0) {
                            setDivisao6FranquiasRows(carregarDadosFranquiaSorteio(conf.nome, div.nome, divisao6FranquiasRows, 6));
                            divisao6FranquiasRows.map(m => lstFranquiaSalvar.push(m));
                        }
                    }
                    else if (index === 2) {
                        if (divisao7FranquiasRows.length <= 0) {
                            setDivisao7FranquiasRows(carregarDadosFranquiaSorteio(conf.nome, div.nome, divisao7FranquiasRows, 7));
                            divisao7FranquiasRows.map(m => lstFranquiaSalvar.push(m));
                        }
                    }
                    else {
                        if (divisao8FranquiasRows.length <= 0) {
                            setDivisao8FranquiasRows(carregarDadosFranquiaSorteio(conf.nome, div.nome, divisao8FranquiasRows, 8));
                            divisao8FranquiasRows.map(m => lstFranquiaSalvar.push(m));
                        }
                    }
                }
            })
        });
    }

    const handleOpenCloseFreeAgency = () => {

        setOpenCloseFreeAgency(!openCloseFreeAgency);
        setLabelOpenCloseFA(openCloseFreeAgency ? "Abrir" : "Fechar");
        formRef.current?.setFieldValue("free_Agency.situacao", openCloseFreeAgency);
        let data = formRef.current?.getData();

        let date = new Date(new Date().toString().split('GMT')[0] + ' UTC').toISOString().split('.')[0];
        if (!openCloseFreeAgency) {
            setData_Abertura_FA(date);
            // formRef.current?.setFieldValue("free_agency.data_Abertura", date);
            // data = {
            //     ...data, free_Agency: {
            //         ...data?.free_Agency,
            //         data_Abertura: date,
            //         situacao: openCloseFreeAgency
            //     }
            // }
            setData_Encerramento_FA("");
            formRef.current?.setFieldValue("free_agency.data_Encerramento", "");
            // data = {
            //     ...data, free_Agency: {
            //         ...data?.free_Agency,
            //         data_Encerramento: "",
            //         situacao: openCloseFreeAgency
            //     }
            // }
            setDadosFreeAgency({
                ...dadosFreeAgency,
                situacao: openCloseFreeAgency,
                data_Abertura: date,
                data_Encerramento: null
            });
        }
        else {
            setData_Encerramento_FA(date);
            setDadosFreeAgency({
                ...dadosFreeAgency,
                situacao: openCloseFreeAgency,
                data_Abertura: dadosFreeAgency?.data_Abertura ?? null,
                data_Encerramento: date
            });
            formRef.current?.setFieldValue("free_agency.data_Encerramento", date);
            // data = {
            //     ...data, free_Agency: {
            //         ...data?.free_Agency,
            //         data_Encerramento: date,
            //         situacao: openCloseFreeAgency
            //     }
            // }
        }

        //formRef.current?.setData(data);
        setAtualizarFreeAgency(true);



    }

    const handleOpenCloseMercado = () => {
        setOpenCloseMercado(!openCloseMercado);
        setLabelOpenCloseME(openCloseMercado ? "Abrir" : "Fechar");
        formRef.current?.setFieldValue("configuracao_Liga.situacao_Mercado ", openCloseMercado);
        let data = formRef.current?.getData();
        //console.log(data);
        let date = new Date(new Date().toString().split('GMT')[0] + ' UTC').toISOString().split('.')[0];
        if (!openCloseMercado) {
            setData_Abertura_ME(date);
            formRef.current?.setFieldValue("configuracao_Liga.data_Abertura_Mercado", date);
            data = {
                ...data, configuracao_Liga: {
                    ...data?.configuracao_Liga,
                    data_Abertura_Mercado: date,
                    situacao_Mercado: openCloseDraft
                }
            }

            setData_Encerramento_ME("");
            formRef.current?.setFieldValue("configuracao_Liga.data_Encerramento_Mercado", "");
            data = {
                ...data, configuracao_Liga: {
                    ...data?.configuracao_Liga,
                    data_Encerramento_Mercado: "",
                    situacao_Mercado: openCloseDraft
                }
            }
        }
        else {
            setData_Encerramento_ME(date);
            formRef.current?.setFieldValue("configuracao_Liga.data_Encerramento_Mercado", date);
            data = {
                ...data, configuracao_Liga: {
                    ...data?.configuracao_Liga,
                    data_Encerramento_Mercado: date,
                    situacao_Mercado: openCloseDraft
                }
            }
        }

        formRef.current?.setData(data);
        //console.log(data);
    }

    const handleOpenCloseTrocaPosicao = () => {
        setOpenCloseTrocaPosicao(!openCloseTrocaPosicao);
        setLabelOpenCloseTrocaPosicao(openCloseTrocaPosicao ? "Abrir" : "Fechar");
        formRef.current?.setFieldValue("configuracao_Liga.situacao_Troca_Posicao ", openCloseTrocaPosicao);
        let data = formRef.current?.getData();
        let date = new Date(new Date().toString().split('GMT')[0] + ' UTC').toISOString().split('.')[0];
        if (!openCloseTrocaPosicao) {
            setData_Abertura_TP(date);
            formRef.current?.setFieldValue("configuracao_Liga.data_Abertura_Troca_Posicao", date);
            data = {
                ...data, configuracao_Liga: {
                    ...data?.configuracao_Liga,
                    data_Abertura_Troca_Posicao: date,
                    situacao_Troca_Posicao: openCloseTrocaPosicao
                }
            }

            setData_Encerramento_TP("");
            formRef.current?.setFieldValue("configuracao_Liga.data_Encerramento_Troca_Posicao", "");
            data = {
                ...data, configuracao_Liga: {
                    ...data?.configuracao_Liga,
                    data_Encerramento_Troca_Posicao: "",
                    situacao_TrocaPosicao: openCloseTrocaPosicao
                }
            }
        }
        else {
            setData_Encerramento_TP(date);
            formRef.current?.setFieldValue("configuracao_Liga.data_Encerramento_Troca_Posicao", date);
            data = {
                ...data, configuracao_Liga: {
                    ...data?.configuracao_Liga,
                    data_Encerramento_Troca_Posicao: date,
                    situacao_TrocaPosicao: openCloseTrocaPosicao
                }
            }
        }
        formRef.current?.setData(data);
    }

    const handleOpenCloseLeilao = () => {       
        setOpenCloseLeilao(!openCloseLeilao);
        setLabelOpenCloseLeilao(openCloseLeilao ? "Abrir" : "Fechar");
        setAtualizarLeilao(true);
        formRef.current?.setFieldValue("leilao.situacao", openCloseLeilao);
        let data = formRef.current?.getData();
        let date = new Date(new Date().toString().split('GMT')[0] + ' UTC').toISOString().split('.')[0];
        if (!openCloseLeilao) {            
            setData_Abertura_LE(date);
            formRef.current?.setFieldValue("leilao.data_Abertura", date);
            data = {
                ...data, leilao: {
                    ...data?.leilao,
                    data_Abertura: date,
                }
            }
            setData_Encerramento_LE("");
            formRef.current?.setFieldValue("leilao.data_Encerramento", "");
            data = {
                ...data, leilao: {
                    ...data?.leilao,
                    data_Encerramento: "",
                }
            }
        }
        else {            
            setData_Encerramento_LE(date);
            formRef.current?.setFieldValue("leilao.data_Encerramento", date);
            data = {
                ...data, leilao: {
                    ...data?.leilao,
                    data_Encerramento: date,
                }
            }
        }

        formRef.current?.setData(data);
        setDadosLeilao(data as IDadosLeilao);
        // console.log("data leilao");
        // console.log(data);
    }

    const handleLiberarEncerrarEstouroLimites = () => {
        setLiberarEncerrar(!liberarEncerrar);
        setLabelLiberarEncerrar(liberarEncerrar ? "Liberar" : "Encerrar");
        formRef.current?.setFieldValue("liberacoes_Liga.situacao", liberarEncerrar);
        let dados = formRef.current?.getData();
        let date = new Date(new Date().toString().split('GMT')[0] + ' UTC').toISOString().split('.')[0];
        if (!liberarEncerrar) {
            setData_Inicio_EL(date);
            formRef.current?.setFieldValue("liberacoes_Liga.data_Inicio", date);
            dados = {
                ...dados, liberacoes_Liga: {
                    ...dados?.liberacoes_Liga,
                    data_Inicio: date
                }
            }

            setData_Encerramento_EL("");
            formRef.current?.setFieldValue("liberacoes_Liga.data_Fim", "");
            dados = {
                ...dados, liberacoes_Liga: {
                    ...dados?.liberacoes_Liga,
                    data_Fim: "",
                }
            }
        }
        else {
            setData_Encerramento_EL(date);
            formRef.current?.setFieldValue("liberacoes_Liga.data_Fim", date);
            dados = {
                ...dados, liberacoes_Liga: {
                    ...dados?.liberacoes_Liga,
                    data_Fim: date,
                }
            }
        }
        formRef.current?.setData(dados);
    }

    const toggleModalMensagem = () => {

        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar.length >= 1) {
            redirecionar.length === 1 ? navigate(0) : navigate(redirecionar);
        }
    };

    const handleChangeTipoFranquia = async (e: any) => {
        let val = e.target.value;
        setTipo(Number(val));
        setTipoEdit(true);
        handleLimparListas();
        let disp = formRef.current?.getData();
        //console.log(val === 1);
        if (val === "1") {
            setFraquiasCriadas(disp?.liberacoes_Liga.data_Sorteio_Franquia !== null && disp?.liberacoes_Liga.data_Sorteio_Franquia !== undefined && new Date(disp.liberacoes_Liga.data_Sorteio_Franquia) <= new Date() ? true : false);
        }
        else {
            setFraquiasCriadas(true);
        }
        setAtualizarConferencia(true);
    }

    useEffect(() => {
        setRemoveLoading(false);
        setIsLoading(true);
        if (tipoEdit === true) {
            if (tipo === 2) {
                setAtualizar_Franquia(true);
                criarGruposDivisao(lstConferenciasRows);
            }
            else {
                setAtualizar_Franquia(true);
                sortearGruposDivisao(lstConferenciasRows);
            }
        }
        const fetchData = async () => {
            if (primeiraTemporada) {
                await CarregarDadosSorteioInicial();
                await CarregarDadosSorteioCalouro();
            }
            setRemoveLoading(true);
            setIsLoading(false);
        }
        fetchData();

    }, [tipo, tempoZerado, tempoZeradoCalouro]);

    const handleLimparListas = () => {
        let a: IDadosFranquiaDisputa[] = []; // divisao1FranquiasRows.filter(f => f.codigo_Franquia === 0);
        for (let i = 1; i <= 8; i++) {
            eval(`setDivisao${i}FranquiasRows([])`);
            for (let j = 0; j < 6; j++) {
                eval(`setDropFranquia${i}${j}(0);`);
            }
        }
    };

    const calcularQtdRodadas = () => {
        setLstQuantidadeRodadas([]);
        const QuantidadeJogosBase = 82;
        let maisVezesDivisao: boolean = false;
        let maisVezesConferencia: boolean = false;

        // let franquiasPorDivisao = 0;
        // switch (qtdFranquias) {
        //     case 12:
        //         franquiasPorDivisao = 3;
        //         break;
        //     case 16:
        //     case 24:
        //     case 32:
        //         franquiasPorDivisao = 4;
        //         break;
        //     case 20:
        //     case 30:
        //         franquiasPorDivisao = 5;
        //         break;
        //     case 28:
        //         franquiasPorDivisao = 7;
        //         break;
        //     // default: franquiasPorDivisao;
        // }

        let quantidadeMelhorDe = melhorDe * 4;
        let quantidadeJogosAllStar = allStarGameLiga === true ? 10 : 0;
        let quantidadePlayIn = playIn === true ? 1 : 0;

        // let quantidadeJogosDivisao = maisVezesDivisao ? franquiasPorDivisao * (franquiasPorDivisao - 1) : 0;
        //  let quantidadeJogosConferencia = maisVezesConferencia ? (qtdFranquias / 2) - 1 : 0;
        let soma = (quantidadeMelhorDe + quantidadeJogosAllStar + quantidadePlayIn);
        setQuantidadesJogos(QuantidadeJogosBase - soma);
        let valorQtdRodadas: any[] = [];
        for (let i = 5; i <= quantidadesJogos; i++) {
            valorQtdRodadas.push({ codigo: i, label: i })
        }

        setLstQuantidadeRodadas(valorQtdRodadas);

    }

    useEffect(() => {
        calcularQtdRodadas();
    }, [allStarGameLiga, playIn, quantidadesJogos, melhorDe]);

    let timesSorteio: any[] = [{
        rodada: number,
        mandante: number,
        visitante: number
    }];

    const verificarSeJogoExiste = (lista: any[], listaAux: IDadosFranquiaDisputa[], mandante: number | undefined, visitante: number | undefined, rodada: number) => {
        let existe = lista.filter(e => (e.mandante === mandante && e.visitante === visitante));

        if (existe.length > 0) {

            listaAux = listaAux.filter(f => f.codigo_Franquia !== visitante);
            visitante = listaAux.find(v => (v.codigo_Franquia !== mandante))?.codigo_Franquia;
            if (visitante === undefined) {
                return;
            }
            verificarSeJogoExiste(lista, listaAux, mandante, visitante, rodada);
        }

        return visitante;
    }

    // const handleCriarConfrontos = async (quantidade_Rodadas: number) => {
    //     timesSorteio = [];
    //     setAtualizaCanlendario(true);
    //     setShowRodadasTabs(false);
    //     setQtdRodadasEscolidas([]);
    //     setValoresTimeSorteio(timesSorteio);

    //     let disp = formRef.current?.getData();
    //     let rodada = 1;
    //     let maxRodada = 0;
    //     let rodadas = quantidade_Rodadas > (qtdFranquias - 1) ? qtdFranquias - 1 : quantidade_Rodadas;
    //     let qtdTimes = lstTodasFranquias.length;
    //     let qtdConfrontos = quantidade_Rodadas * (qtdFranquias / 2);


    //     if (disp?.configuracao_Calendario_Liga.enfrentar_Mais_Vezes_Divisao === true) {
    //         let qtdJogDiv = divisao1FranquiasRows.length - 1;
    //         let qtdFranquiasDiv = divisao1FranquiasRows.length;
    //         let lstAux: IDadosFranquiaDisputa[] = [];
    //         for (let r = rodada; r <= (qtdFranquiasDiv / 2); r++) {
    //             let visitante: number | undefined = 0;
    //             lstAux = divisao1FranquiasRows;
    //             divisao1FranquiasRows.map((d1, index) => {
    //                 let existe = timesSorteio.find(f => (r === f.rodada && (f.visitante === d1.codigo_Franquia || f.mandante === d1.codigo_Franquia)));
    //                 if (existe === undefined) {
    //                     visitante = r % 2 === 0 ? lstAux.slice(-1).find(v => (v.codigo_Franquia !== d1.codigo_Franquia))?.codigo_Franquia : lstAux.find(v => (v.codigo_Franquia !== d1.codigo_Franquia))?.codigo_Franquia;
    //                     if (visitante !== undefined) {
    //                         let res = verificarSeJogoExiste(timesSorteio, lstAux, d1.codigo_Franquia, visitante, r);
    //                         if (res === undefined) {
    //                             return;
    //                         }
    //                         visitante = res;
    //                     }
    //                     if (lstAux.length % 2 === 0) {
    //                         timesSorteio.push({
    //                             rodada: r,
    //                             mandante: d1.codigo_Franquia,
    //                             visitante: visitante
    //                         });
    //                     }
    //                     else {
    //                         if (lstAux.length === 1) {
    //                             visitante = divisao2FranquiasRows.find((f, idx) => index === idx)?.codigo_Franquia;
    //                         }
    //                         timesSorteio.push({
    //                             rodada: r,
    //                             mandante: d1.codigo_Franquia,
    //                             visitante: visitante

    //                         });
    //                     }
    //                     lstAux = lstAux.filter(f => f.codigo_Franquia !== visitante && f.codigo_Franquia !== d1.codigo_Franquia);
    //                 }
    //             });
    //             lstAux = divisao2FranquiasRows;
    //             if (visitante !== undefined) {
    //                 lstAux = lstAux.filter(f => f.codigo_Franquia !== visitante);
    //             }
    //             divisao2FranquiasRows.map((d2, index) => {
    //                 let existe = timesSorteio.find(f => (r === f.rodada && (f.visitante === d2.codigo_Franquia || f.mandante === d2.codigo_Franquia)));
    //                 if (existe === undefined) {
    //                     visitante = r % 2 === 0 ? lstAux.slice(-1).find(v => (v.codigo_Franquia !== d2.codigo_Franquia))?.codigo_Franquia : lstAux.find(v => (v.codigo_Franquia !== d2.codigo_Franquia))?.codigo_Franquia;
    //                     if (visitante !== undefined) {
    //                         let res = verificarSeJogoExiste(timesSorteio, lstAux, d2.codigo_Franquia, visitante, r);
    //                         if (res === undefined) {
    //                             return;
    //                         }
    //                         visitante = res;
    //                     }
    //                     if (lstAux.length % 2 === 0) {
    //                         timesSorteio.push({
    //                             rodada: r,
    //                             mandante: d2.codigo_Franquia,
    //                             visitante: visitante
    //                         });
    //                     }
    //                     else {
    //                         timesSorteio.push({
    //                             rodada: r,
    //                             mandante: d2.codigo_Franquia,
    //                             visitante: visitante

    //                         });
    //                     }
    //                     lstAux = lstAux.filter(f => f.codigo_Franquia !== visitante && f.codigo_Franquia !== d2.codigo_Franquia);
    //                 }
    //             });

    //             if (divisao3FranquiasRows.length > 0) {
    //                 lstAux = divisao3FranquiasRows;
    //                 divisao3FranquiasRows.map((d3, index) => {
    //                     let existe = timesSorteio.find(f => (f.rodada === r && (f.visitante === d3.codigo_Franquia || f.mandante === d3.codigo_Franquia)));
    //                     if (existe === undefined) {
    //                         visitante = r % 2 === 0 ? lstAux.slice(-1).find(v => (v.codigo_Franquia !== d3.codigo_Franquia))?.codigo_Franquia : lstAux.find(v => (v.codigo_Franquia !== d3.codigo_Franquia))?.codigo_Franquia;
    //                         if (visitante !== undefined) {
    //                             let res = verificarSeJogoExiste(timesSorteio, lstAux, d3.codigo_Franquia, visitante, r);
    //                             if (res === undefined) {
    //                                 return;
    //                             }
    //                             visitante = res;
    //                         }
    //                         if (lstAux.length % 2 === 0) {
    //                             timesSorteio.push({
    //                                 rodada: r,
    //                                 mandante: d3.codigo_Franquia,
    //                                 visitante: visitante
    //                             });
    //                         }
    //                         else {
    //                             if (lstAux.length === 1) {
    //                                 visitante = divisao4FranquiasRows.length > 0
    //                                     ? divisao4FranquiasRows.find((f, idx) => index === idx)?.codigo_Franquia
    //                                     : divisao7FranquiasRows.find((f, idx) => index === idx)?.codigo_Franquia;
    //                             }
    //                             timesSorteio.push({
    //                                 rodada: r,
    //                                 mandante: d3.codigo_Franquia,
    //                                 visitante: visitante

    //                             });
    //                         }
    //                         lstAux = lstAux.filter(f => f.codigo_Franquia !== visitante && f.codigo_Franquia !== d3.codigo_Franquia);
    //                     }
    //                 });
    //             }

    //             if (divisao4FranquiasRows.length > 0) {
    //                 lstAux = divisao4FranquiasRows;
    //                 if (visitante !== undefined) {
    //                     lstAux = lstAux.filter(f => f.codigo_Franquia !== visitante);
    //                 }
    //                 divisao4FranquiasRows.map((d4, index) => {
    //                     let existe = timesSorteio.find(f => (f.rodada === r && (f.visitante === d4.codigo_Franquia || f.mandante === d4.codigo_Franquia)));
    //                     if (existe === undefined) {
    //                         visitante = r % 2 === 0 ? lstAux.slice(-1).find(v => (v.codigo_Franquia !== d4.codigo_Franquia))?.codigo_Franquia : lstAux.find(v => (v.codigo_Franquia !== d4.codigo_Franquia))?.codigo_Franquia;
    //                         if (visitante !== undefined) {
    //                             let res = verificarSeJogoExiste(timesSorteio, lstAux, d4.codigo_Franquia, visitante, r);
    //                             if (res === undefined) {
    //                                 return;
    //                             }
    //                             visitante = res;
    //                         }
    //                         if (lstAux.length % 2 === 0) {
    //                             timesSorteio.push({
    //                                 rodada: r,
    //                                 mandante: d4.codigo_Franquia,
    //                                 visitante: visitante
    //                             });
    //                         }
    //                         else {
    //                             timesSorteio.push({
    //                                 rodada: r,
    //                                 mandante: d4.codigo_Franquia,
    //                                 visitante: visitante
    //                             });
    //                         }
    //                         lstAux = lstAux.filter(f => f.codigo_Franquia !== visitante && f.codigo_Franquia !== d4.codigo_Franquia);
    //                     }
    //                 });
    //             }

    //             lstAux = divisao5FranquiasRows;
    //             divisao5FranquiasRows.map((d5, index) => {
    //                 let existe = timesSorteio.find(f => (r === f.rodada && (f.visitante === d5.codigo_Franquia || f.mandante === d5.codigo_Franquia)));
    //                 if (existe === undefined) {
    //                     visitante = r % 2 === 0 ? lstAux.slice(-1).find(v => (v.codigo_Franquia !== d5.codigo_Franquia))?.codigo_Franquia : lstAux.find(v => (v.codigo_Franquia !== d5.codigo_Franquia))?.codigo_Franquia;
    //                     if (visitante !== undefined) {
    //                         let res = verificarSeJogoExiste(timesSorteio, lstAux, d5.codigo_Franquia, visitante, r);
    //                         if (res === undefined) {
    //                             return;
    //                         }
    //                         visitante = res;
    //                     }
    //                     if (lstAux.length % 2 === 0) {
    //                         timesSorteio.push({
    //                             rodada: r,
    //                             mandante: d5.codigo_Franquia,
    //                             visitante: visitante
    //                         });
    //                     }
    //                     else {
    //                         if (lstAux.length === 1) {
    //                             visitante = divisao6FranquiasRows.find((f, idx) => index === idx)?.codigo_Franquia;
    //                         }
    //                         timesSorteio.push({
    //                             rodada: r,
    //                             mandante: d5.codigo_Franquia,
    //                             visitante: visitante

    //                         });
    //                     }
    //                     lstAux = lstAux.filter(f => f.codigo_Franquia !== visitante && f.codigo_Franquia !== d5.codigo_Franquia);
    //                 }

    //             });
    //             lstAux = divisao6FranquiasRows;
    //             if (visitante !== undefined) {
    //                 lstAux = lstAux.filter(f => f.codigo_Franquia !== visitante);
    //             }
    //             divisao6FranquiasRows.map((d6, index) => {
    //                 let existe = timesSorteio.find(f => (r === f.rodada && (f.visitante === d6.codigo_Franquia || f.mandante === d6.codigo_Franquia)));
    //                 if (existe === undefined) {
    //                     visitante = r % 2 === 0 ? lstAux.slice(-1).find(v => (v.codigo_Franquia !== d6.codigo_Franquia))?.codigo_Franquia : lstAux.find(v => (v.codigo_Franquia !== d6.codigo_Franquia))?.codigo_Franquia;
    //                     if (visitante !== undefined) {
    //                         let res = verificarSeJogoExiste(timesSorteio, lstAux, d6.codigo_Franquia, visitante, r);
    //                         if (res === undefined) {
    //                             return;
    //                         }
    //                         visitante = res;
    //                     }
    //                     if (lstAux.length % 2 === 0) {
    //                         timesSorteio.push({
    //                             rodada: r,
    //                             mandante: d6.codigo_Franquia,
    //                             visitante: visitante
    //                         });
    //                     }
    //                     else {
    //                         timesSorteio.push({
    //                             rodada: r,
    //                             mandante: d6.codigo_Franquia,
    //                             visitante: visitante
    //                         });
    //                     }
    //                     lstAux = lstAux.filter(f => f.codigo_Franquia !== visitante && f.codigo_Franquia !== d6.codigo_Franquia);
    //                 }
    //             });

    //             if (divisao7FranquiasRows.length > 0) {
    //                 lstAux = divisao7FranquiasRows;
    //                 divisao7FranquiasRows.map((d7, index) => {
    //                     let existe = timesSorteio.find(f => (f.rodada === r && (f.visitante === d7.codigo_Franquia || f.mandante === d7.codigo_Franquia)));
    //                     if (existe === undefined) {
    //                         visitante = r % 2 === 0 ? lstAux.slice(-1).find(v => (v.codigo_Franquia !== d7.codigo_Franquia))?.codigo_Franquia : lstAux.find(v => (v.codigo_Franquia !== d7.codigo_Franquia))?.codigo_Franquia;
    //                         if (visitante !== undefined) {
    //                             let res = verificarSeJogoExiste(timesSorteio, lstAux, d7.codigo_Franquia, visitante, r);
    //                             if (res === undefined) {
    //                                 return;
    //                             }
    //                             visitante = res;
    //                         }
    //                         if (lstAux.length % 2 === 0) {
    //                             timesSorteio.push({
    //                                 rodada: r,
    //                                 mandante: d7.codigo_Franquia,
    //                                 visitante: visitante
    //                             });
    //                         }
    //                         else {
    //                             timesSorteio.push({
    //                                 rodada: r,
    //                                 mandante: d7.codigo_Franquia,
    //                                 visitante: visitante

    //                             });
    //                         }
    //                         lstAux = lstAux.filter(f => f.codigo_Franquia !== visitante && f.codigo_Franquia !== d7.codigo_Franquia);
    //                     }

    //                 });
    //             }

    //             if (divisao8FranquiasRows.length > 0) {
    //                 lstAux = divisao8FranquiasRows;
    //                 if (visitante !== undefined) {
    //                     lstAux = lstAux.filter(f => f.codigo_Franquia !== visitante);
    //                 }
    //                 divisao8FranquiasRows.map((d8, index) => {
    //                     let existe = timesSorteio.find(f => (f.rodada === r && (f.visitante === d8.codigo_Franquia || f.mandante === d8.codigo_Franquia)));
    //                     if (existe === undefined) {
    //                         visitante = r % 2 === 0 ? lstAux.slice(-1).find(v => (v.codigo_Franquia !== d8.codigo_Franquia))?.codigo_Franquia : lstAux.find(v => (v.codigo_Franquia !== d8.codigo_Franquia))?.codigo_Franquia;
    //                         if (visitante !== undefined) {
    //                             let res = verificarSeJogoExiste(timesSorteio, lstAux, d8.codigo_Franquia, visitante, r);
    //                             if (res === undefined) {
    //                                 return;
    //                             }
    //                             visitante = res;
    //                         }
    //                         if (lstAux.length % 2 === 0) {
    //                             timesSorteio.push({
    //                                 rodada: r,
    //                                 mandante: d8.codigo_Franquia,
    //                                 visitante: visitante

    //                             });
    //                         }
    //                         else {
    //                             timesSorteio.push({
    //                                 rodada: r,
    //                                 mandante: d8.codigo_Franquia,
    //                                 visitante: visitante

    //                             });
    //                         }
    //                         lstAux = lstAux.filter(f => f.codigo_Franquia !== visitante && f.codigo_Franquia !== d8.codigo_Franquia);
    //                     }
    //                 });
    //             }
    //         }
    //         // console.log("Mais Divisão");
    //         // console.log(timesSorteio);
    //         maxRodada = timesSorteio.reduce(function (prev, current) {
    //             return prev.rodada > current.rodada ? prev.rodada : current.rodada
    //         });
    //         maxRodada = maxRodada + 1;
    //     }

    //     if (disp?.configuracao_Calendario_Liga.enfrentar_Mais_Vezes_Conferencia === true) {

    //         let timesSorteioConferencias: any[] = [];
    //         let lstFranquiasConf1Rows: IDadosFranquiaDisputa[] = [];
    //         let lstFranquiasConf2Rows: IDadosFranquiaDisputa[] = [];

    //         let a = divisao1FranquiasRows.length > 0 ? divisao1FranquiasRows.map(m => lstFranquiasConf1Rows.push(m)) : [];
    //         a = divisao2FranquiasRows.length > 0 ? divisao2FranquiasRows.map(m => lstFranquiasConf1Rows.push(m)) : [];
    //         a = divisao3FranquiasRows.length > 0 ? divisao3FranquiasRows.map(m => lstFranquiasConf1Rows.push(m)) : [];
    //         a = divisao4FranquiasRows.length > 0 ? divisao4FranquiasRows.map(m => lstFranquiasConf1Rows.push(m)) : [];
    //         a = divisao5FranquiasRows.length > 0 ? divisao5FranquiasRows.map(m => lstFranquiasConf2Rows.push(m)) : [];
    //         a = divisao6FranquiasRows.length > 0 ? divisao6FranquiasRows.map(m => lstFranquiasConf2Rows.push(m)) : [];
    //         a = divisao7FranquiasRows.length > 0 ? divisao7FranquiasRows.map(m => lstFranquiasConf2Rows.push(m)) : [];
    //         a = divisao8FranquiasRows.length > 0 ? divisao8FranquiasRows.map(m => lstFranquiasConf2Rows.push(m)) : [];
    //         let qtdJogConf = lstFranquiasConf1Rows.length - 1;
    //         let qtdJogos = (qtdJogConf + maxRodada) > rodadas ? rodadas : qtdJogConf;


    //         let lstAux: IDadosFranquiaDisputa[] = [];
    //         for (let r = maxRodada; r <= qtdJogos; r++) {
    //             let visitante: number | undefined = 0;
    //             lstAux = lstFranquiasConf1Rows;
    //             lstFranquiasConf1Rows.map((c1, index) => {
    //                 let existe = timesSorteioConferencias.find(f => (r === f.rodada && (f.visitante === c1.codigo_Franquia || f.mandante === c1.codigo_Franquia)));
    //                 if (existe === undefined) {
    //                     visitante = lstAux.find(v => v.codigo_Franquia !== c1.codigo_Franquia) !== undefined ? lstAux.filter(v => v.codigo_Franquia !== c1.codigo_Franquia).pop()?.codigo_Franquia : undefined;
    //                     if (visitante !== undefined) {
    //                         visitante = verificarSeJogoExiste(timesSorteioConferencias, lstAux, c1.codigo_Franquia, visitante, r)
    //                     }
    //                     if (visitante !== undefined) {
    //                         timesSorteioConferencias.push({
    //                             rodada: r,
    //                             mandante: c1.codigo_Franquia,
    //                             visitante: visitante
    //                         });
    //                     }
    //                     lstAux = lstAux.filter(f => f.codigo_Franquia !== visitante && f.codigo_Franquia !== c1.codigo_Franquia);
    //                 }
    //             });
    //             lstAux = lstFranquiasConf2Rows;
    //             lstFranquiasConf2Rows.map((c2, index) => {
    //                 let existe = timesSorteioConferencias.find(f => (r === f.rodada && (f.visitante === c2.codigo_Franquia || f.mandante === c2.codigo_Franquia)));
    //                 if (existe === undefined) {
    //                     visitante = lstAux.find(v => v.codigo_Franquia !== c2.codigo_Franquia) !== undefined ? lstAux.filter(v => v.codigo_Franquia !== c2.codigo_Franquia).pop()?.codigo_Franquia : undefined;
    //                     if (visitante !== undefined) {
    //                         visitante = verificarSeJogoExiste(timesSorteioConferencias, lstAux, c2.codigo_Franquia, visitante, r)
    //                     }
    //                     if (visitante !== undefined) {
    //                         timesSorteioConferencias.push({
    //                             rodada: r,
    //                             mandante: c2.codigo_Franquia,
    //                             visitante: visitante
    //                         });
    //                     }
    //                     lstAux = lstAux.filter(f => f.codigo_Franquia !== visitante && f.codigo_Franquia !== c2.codigo_Franquia);
    //                 }
    //             });

    //         }
    //         maxRodada = timesSorteioConferencias.reduce(function (prev, current) {
    //             return prev.rodada > current.rodada ? prev.rodada : current.rodada
    //         });
    //         maxRodada = maxRodada + 1;
    //         timesSorteio = timesSorteio.concat(timesSorteioConferencias);
    //     }

    //     if (maxRodada < rodadas) {
    //         for (let i = (maxRodada); i <= rodadas; i++) {
    //             for (let x = 0; x < qtdTimes; x++) {
    //                 if (timesSorteio.filter(f => f.rodada === i).length < (qtdFranquias / 2)) {
    //                     let existe = timesSorteio.find(f => (f.visitante === lstTodasFranquias[x].codigo_Franquia && f.rodada === i));
    //                     if (existe === undefined) {
    //                         let y = x + i;
    //                         if (y >= qtdTimes) {
    //                             y = y - qtdTimes;
    //                             existe = timesSorteio.find(f => ((f.mandante === lstTodasFranquias[y].codigo_Franquia || (f.visitante === lstTodasFranquias[y].codigo_Franquia)) && f.rodada === i));
    //                             if (existe !== undefined) {
    //                                 for (let l = 0; l < qtdFranquias; l++) {
    //                                     existe = timesSorteio.find(f => ((f.mandante === lstTodasFranquias[l].codigo_Franquia || f.visitante === lstTodasFranquias[l].codigo_Franquia) && f.rodada === i));
    //                                     if (existe === undefined && lstTodasFranquias[x].codigo_Franquia !== lstTodasFranquias[l].codigo_Franquia) {
    //                                         timesSorteio.push({
    //                                             rodada: i,
    //                                             mandante: lstTodasFranquias[x].codigo_Franquia,
    //                                             visitante: lstTodasFranquias[l].codigo_Franquia
    //                                         });
    //                                         break;
    //                                     }
    //                                 }
    //                             }
    //                             else {
    //                                 if (lstTodasFranquias[x].codigo_Franquia !== lstTodasFranquias[y].codigo_Franquia) {
    //                                     timesSorteio.push({
    //                                         rodada: i,
    //                                         mandante: lstTodasFranquias[x].codigo_Franquia,
    //                                         visitante: lstTodasFranquias[y].codigo_Franquia
    //                                     });
    //                                 }
    //                             }
    //                         }
    //                         else {
    //                             if (lstTodasFranquias[x].codigo_Franquia !== lstTodasFranquias[y].codigo_Franquia) {
    //                                 timesSorteio.push({
    //                                     rodada: i,
    //                                     mandante: lstTodasFranquias[x].codigo_Franquia,
    //                                     visitante: lstTodasFranquias[y].codigo_Franquia
    //                                 });
    //                             }
    //                         }
    //                     }
    //                 }
    //             }
    //         }
    //     }

    //     if (qtdConfrontos > timesSorteio.length) {
    //         let totalConfronto = Math.trunc(quantidade_Rodadas / (qtdTimes - 1));
    //         let restoRodadas = quantidade_Rodadas % (qtdTimes - 1);
    //         let qtdTotalRodadas = rodadas;

    //         for (let i = 1; i < totalConfronto; i++) {
    //             timesSorteio.forEach(f => {
    //                 timesSorteio.push({
    //                     rodada: f.rodada + rodadas,
    //                     mandante: f.mandante,
    //                     visitante: f.visitante
    //                 });
    //             });
    //             qtdTotalRodadas = qtdTotalRodadas + rodadas;
    //         }

    //         for (let i = 1; i <= restoRodadas; i++) {
    //             timesSorteio.filter(y => y.rodada === i).forEach(f => {
    //                 timesSorteio.push({
    //                     rodada: f.rodada + qtdTotalRodadas,
    //                     mandante: f.mandante,
    //                     visitante: f.visitante
    //                 });
    //             });
    //         }
    //     }

    //     setShowRodadasTabs(true);
    //     let rds = timesSorteio.map(m => m.rodada);
    //     let unique = rds.filter((el, i, arr) => arr.indexOf(el) == i);
    //     setQtdRodadasEscolidas(unique);
    //     setValoresTimeSorteio(timesSorteio);
    // }

    //#region Draft Calouro

    const handleOpenCloseDraftCalouro = () => {
        setOpenCloseDraft(!openCloseDraft);
        setLabelOpenCloseDA(openCloseDraft ? "Abrir" : "Fechar");
        setAtualizar_Situacao_Calouro(true);
        formRef.current?.setFieldValue("configuracao_Liga.situacao_Calouro", openCloseDraft);
        let data = formRef.current?.getData();
        //console.log(data);
        let date = new Date(new Date().toString().split('GMT')[0] + ' UTC').toISOString().split('.')[0];
        if (!openCloseDraft) {
            setData_Abertura_Calouro(date);
            formRef.current?.setFieldValue("configuracao_Liga.data_Abertura_Calouro", date);
            data = {
                ...data, configuracao_Liga: {
                    ...data?.configuracao_Liga,
                    data_Abertura_Calouro: date,
                    situacao_Calouro: openCloseDraft
                }
            }
        }
        else {
            setData_Encerramento_Calouro(date);
            formRef.current?.setFieldValue("configuracao_Liga.data_Encerramento_Calouro", date);
            data = {
                ...data, configuracao_Liga: {
                    ...data?.configuracao_Liga,
                    data_Encerramento_Calouro: date,
                    situacao_Calouro: openCloseDraft
                }
            }
        }

        formRef.current?.setData(data);
        //console.log(data);
    }

    //#endregion

    //#region Draft Inicial
    const handleOpenCloseDraftInicial = () => {
        setOpenCloseDraftInicial(!openCloseDraftInicial);
        setLabelOpenCloseDAInicial(openCloseDraftInicial ? "Abrir" : "Fechar");
        setAtualizar_Situacao_Inicial(true);
        formRef.current?.setFieldValue("configuracao_Liga.situacao_Inicial", openCloseDraftInicial);
        let data = formRef.current?.getData();
        //console.log(data);
        let date = new Date(new Date().toString().split('GMT')[0] + ' UTC').toISOString().split('.')[0];
        if (!openCloseDraftInicial) {
            setData_Abertura_DA(date);
            formRef.current?.setFieldValue("configuracao_Liga.data_Abertura_Inicial", date);
            data = {
                ...data, configuracao_Liga: {
                    ...data?.configuracao_Liga,
                    data_Abertura_Inicial: date,
                    situacao_Inicial: openCloseDraftInicial
                }
            }
        }
        else {
            setData_Encerramento_DA(date);
            formRef.current?.setFieldValue("configuracao_Liga.data_Encerramento_Inicial", date);
            data = {
                ...data, configuracao_Liga: {
                    ...data?.configuracao_Liga,
                    data_Encerramento_Inicial: date,
                    situacao_Inicial: openCloseDraftInicial
                }
            }
        }

        formRef.current?.setData(data);
        //console.log(data);
    }

    const handleChangeDraftPrimeiraRodada = async (e: any) => {
        let val = e.target.value;
        setShowSorteio(val === "1" ? true : false);
        setPrimeiraRodada(val);
        setAtualizar_Franquia_Escolha(true);

        if (val === "1") {
            //     HandleSorteioPrimeiraRodada();
            exibirDadosSorteio = false;
            setExibirDados(false);
        }
        else {
            exibirDadosSorteio = true;
            setExibirDados(true);
        }
    }

    const sorteioEscolhasFranquias = (listaFranquias: any[]) => {

        let item = listaFranquias[Math.floor(Math.random() * listaFranquias.length)];
        if (listaFranquias.length > 0 && lstEscolhas.find(f => f.codigo_Franquia === item.codigo) !== undefined) {
            sorteioEscolhasFranquias(listaFranquias.filter(f => f.codigo !== item.codigo));
        }
        return item;
    }

    const HandleSorteioPrimeiraRodada = () => {
        let lstAux = lstFranquia;
        lstEscolhas.forEach((f, i) => {
            let item = sorteioEscolhasFranquias(lstAux);
            if (item !== undefined) {
                if (f.escolha_Inicial === i + 1) {
                    f.codigo_Franquia = item.codigo;
                }
                lstAux = lstAux.filter(f => f.codigo !== item.codigo);
            }
        });

        if (lstEscolhas.length > 0) {
            lstEscolhas.forEach(f => {
                if (f.codigo_Franquia !== undefined) {
                    eval(`setFranquiaSelecionada${f.escolha_Inicial}(${f.codigo_Franquia !== undefined ? f.codigo_Franquia : 0})`);
                }
            });
        }
    }

    const handleFranquiaSelecionada = (codigoFranquia: number, escolha: number) => {
        setAtualizar_Franquia_Escolha(true);

        if (lstEscolhas.find(f => f.codigo_Franquia === codigoFranquia && f.escolha_Inicial !== 0)) {
            setShowModalMensagem(true);
            setDadosModal({
                acao: true,
                label: "",
                tipo: "info",
                mensagem: "Franquia já selecionada!",
                display: "none",
                titulo: "Atenção"
            });
            return;
        }
        eval(`setFranquiaSelecionada${escolha}`)(codigoFranquia);
        lstEscolhas.forEach((f, i) => {
            if (f.escolha_Inicial === escolha) {
                f.codigo_Franquia = codigoFranquia;
            }
            else if (i === (escolha - 1)) {
                f.codigo_Franquia = codigoFranquia;
                f.escolha_Inicial = escolha;
            }
        });
    }

    const LimarDropsInicial = () => {
        let novaLista = lstEscolhas.map((f) => ({ ...f, escolha_Inicial: 0, codigo_Franquia: f.codigo_Franquia, posicao_Geral: f.posicao_Geral }));
        setLstEscolhas(novaLista);
        for (let index = 1; index <= qtdFranquias; index++) {
            eval(`setFranquiaSelecionada${index}`)(0);
        }
    }

    const handleRealizarSorteioInicial = async () => {
        setSorteioRealizado(true);
        const dados: IDadosSorteio =
        {
            codigo_Liga: Number(codigoLiga),
            codigo_Temporada: codigoTemporada,
            codigo_Usuario: user.codUsuario
        };

        await DraftService.updateSorteioIncial(dados)
            .then((result) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Sorteio realizado com sucesso!",
                    display: "none",
                    titulo: "Sucesso"
                });

                setRedirecionar("1");

            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });

                    logout();
                    setRedirecionar("0");

                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const handleRealizarSorteioCalouro = async () => {
        setSorteioCalouroRealizado(true);
        const dados: IDadosSorteioCalouro =
        {
            codigo_Liga: Number(codigoLiga),
            codigo_Temporada: codigoTemporada,
            codigo_Usuario: user.codUsuario,
            espelhada: escolha_Espelhada_Draft_Calouro
        };

        await DisputaService.updateSorteioCalouro(dados)
            .then((result) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Sorteio realizado com sucesso!",
                    display: "none",
                    titulo: "Sucesso"
                });

                setRedirecionar("1");

            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });

                    logout();
                    setRedirecionar("0");

                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const [hora1Inicial, setHora1Inicial] = useState<number>(0);
    const [minuto1Inicial, setMinuto1Inicial] = useState<number>(0);
    const [segundo1Inicial, setSegundo1Inicial] = useState<number>(0);
    const UseCountdown = (date: Date, sorteioFinalizado: boolean) => {

        const interval = setInterval(() => {
            let now = moment.tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss')
            const distance = moment(date).diff(now);
            if (distance < 0) {
                setTempoZerado(true);
                clearInterval(interval);
            }

            var hourNumber = Math.floor(distance / (1000 * 60 * 60));
            var minuteNumber = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var secondNumber = Math.floor((distance % (1000 * 60)) / 1000);

            if (hourNumber >= 0) {
                setHora1Inicial(hourNumber);
            }
            if (minuteNumber >= 0) {
                setMinuto1Inicial(minuteNumber);
            }
            if (secondNumber > 0) {
                setSegundo1Inicial(secondNumber);
            }

        }, 1);

        return (
            <Grid container size={{ xs: 12, sm: 10 }} spacing={1} display={"flex"} justifySelf={"center"} justifyContent={"center"}>
                <Grid size={{ xs: 12, sm: 6 }}  >
                    <Typography variant="h6" style={{ fontSize: 18, color: "red" }} >
                        Duração (Hrs):
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }} style={{ color: "red", alignSelf: "center" }}>
                    <span>{hora1Inicial.toString().padStart(2, "0")}</span>
                    <span>:</span>
                    <span>{minuto1Inicial.toString().padStart(2, "0")}</span>
                    <span>:</span>
                    <span>{segundo1Inicial.toString().padStart(2, "0")}</span>
                </Grid>
            </Grid>
        )
    }

    const [hora1Calouro, setHora1Calouro] = useState<number>(0);
    const [minuto1Calouro, setMinuto1Calouro] = useState<number>(0);
    const [segundo1Calouro, setSegundo1Calouro] = useState<number>(0);


    const UseCountdownCalouro = (date: Date, sorteioFinalizado: boolean) => {

        const interval = setInterval(() => {
            let now = moment.tz('America/Sao_Paulo').format('YYYY-MM-DD HH:mm:ss')
            const distance = moment(date).diff(now);
            if (distance < 0) {
                setTempoZeradoCalouro(true);
                clearInterval(interval);
            }

            var hourNumber = Math.floor(distance / (1000 * 60 * 60));
            var minuteNumber = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var secondNumber = Math.floor((distance % (1000 * 60)) / 1000);

            if (hourNumber >= 0) {
                setHora1Calouro(hourNumber);
            }
            if (minuteNumber >= 0) {
                setMinuto1Calouro(minuteNumber);
            }
            if (secondNumber > 0) {
                setSegundo1Calouro(secondNumber);
            }

        }, 1);

        return (
            <Grid container size={{ xs: 12, sm: 10 }} spacing={1} display={"flex"} justifySelf={"center"} justifyContent={"center"}>
                <Grid size={{ xs: 12, sm: 6 }}  >
                    <Typography variant="h6" style={{ fontSize: 18, color: "red" }} >
                        Duração (Hrs):
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 6 }} style={{ color: "red", alignSelf: "center" }}>
                    <span>{hora1Calouro.toString().padStart(2, "0")}</span>
                    <span>:</span>
                    <span>{minuto1Calouro.toString().padStart(2, "0")}</span>
                    <span>:</span>
                    <span>{segundo1Calouro.toString().padStart(2, "0")}</span>
                </Grid>
            </Grid>
        )
    }

    //#endregion

    const handleCheckRodadaEspelhada = async (e: any) => {
        setEscolha_Espelhada_Draft_Calouro(e.target.checked);
    }

    // const handleLimparCampos = () => {
    //     setValoresTimeSorteio([]);
    // }

    //#region Copinha
    const handleSorteioCopinha = async () => {
        setIsLoading(true);
        setShowModalMensagem(false);
        await DisputaService.updateSorteioCopinhaById(Number(codigoLiga), codigoTemporada)
            .then((result) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "success",
                    mensagem: "Sorteio realizado com sucesso!",
                    display: "none",
                    titulo: "Sucesso"
                });

                setTimeout(() => { setRedirecionar("0"); }, 3000);

            }).catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                if (errors.response.status === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });

                    logout();
                    setRedirecionar("0");

                    return;
                }
                setDadosModal({
                    acao: true,
                    label: "",
                    tipo: "error",
                    mensagem: errors.response.data.mensagem,
                    display: "none",
                    titulo: "Atenção"
                });
                return;
            });
    }

    const handleCarregarDadosSorteioCopinha = async (codigoTemp: number) => {
        await DisputaService.getDadosCopinhaPorCodigoLigaTemporada(Number(codigoLiga), codigoTemp)
            .then((result) => {
                let dados = result.dado;
                setDadosCopinha(dados);
            })
            .catch((errors) => {
                setIsLoading(false);
                setShowModalMensagem(true);
                setRemoveLoading(true);
                //console.log(errors);
                if (errors.response != undefined && errors.response.data.statusHTTP === 401) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Sessão expirada!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    logout();
                    setRedirecionar("0");
                    return;
                }
                if (errors.response !== undefined && errors.response.data.mensagem !== undefined) {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: errors.response.data.mensagem,
                        display: "none",
                        titulo: "Atenção"
                    });
                    return;
                }
                else {
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "info",
                        mensagem: "Não foi possível carregar os dados de grupos da copinha! Favor entrar em contato com a TI ",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar(`/usuario/liga/${codLocal}`);
                    return;
                }
            });
    }


    //#endregion

    return (
        <LayoutBaseDePagina
            titulo={"Disputa - " + nomeLiga}
            showLogoImg={logoImage}
            barraDeFerramentas={
                <FerramentasDeDetalhe
                    mostrarBotaoApagar={usuarioComissario}
                    mostrarBotaoSalvar={usuarioComissario || user.administrador}
                    mostrarBotaoSalvarEFechar={usuarioComissario}

                    mostrarBotaoNovo={false}
                    aoClicarEmSalvar={save}
                    aoClicarEmSalvarEFechar={saveAndClose}
                    aoClicarEmApagar={() => handleDelete(Number(codigoLiga))}
                    aoClicarEmNovo={() => navigate("/disputa/detalhe/nova")}
                    aoClicarEmVoltar={() => navigate(`/usuario/liga/${codLocal}`)}
                />
            }
        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <VForm ref={formRef} onSubmit={handleSave}>
                <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined">
                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={2}>
                        <Grid alignItems="center" justifyContent="center" width="100%">
                            <Paper>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider', fontWeight: "bold" }}>
                                    <Tabs value={value} variant="scrollable"
                                        scrollButtons onChange={handleChangeTabs}>
                                        <Tab label="Tabela"
                                            sx={{ fontWeight: (temporadaIniciada || !usuarioComissario) && !user.administrador ? "auto" : "bold" }}
                                            disabled={(temporadaIniciada || !usuarioComissario) && !user.administrador}
                                            {...a11yProps(0)} />
                                        <Tab label="Draft Ordem Inicial"
                                            sx={{ fontWeight: !primeiraTemporada || liberarEdicao === false || temporadaIniciada ? "auto" : "bold" }}
                                            disabled={!primeiraTemporada || liberarEdicao === false || temporadaIniciada}
                                            {...a11yProps(1)} />
                                        <Tab label="Draft Ordem Calouro"
                                            sx={{ fontWeight: !primeiraTemporada || liberarEdicao === false || temporadaIniciada ? "auto" : "bold" }}
                                            disabled={!primeiraTemporada || liberarEdicao === false || temporadaIniciada}
                                            {...a11yProps(2)}
                                        />
                                        <Tab label="Liberações Liga"
                                            sx={{ fontWeight: liberarEdicao === false || !usuarioComissario || !user.administrador ? "auto" : "bold" }}
                                            disabled={(liberarEdicao === false || !usuarioComissario) && !user.administrador}
                                            {...a11yProps(3)} />
                                        <Tab
                                            label="Calendário"
                                            sx={{ fontWeight: liberarEdicao === false || temporadaIniciada || !usuarioComissario ? "auto" : "bold" }}
                                            disabled={liberarEdicao === false || temporadaIniciada || !usuarioComissario}
                                            //    onClick={handleLimparCampos}
                                            {...a11yProps(4)}
                                        />
                                        <Tab
                                            label="Copinha"
                                            sx={{ fontWeight: "bold" }}
                                            disabled={!usuarioComissario && !user.administrador}
                                            //    onClick={handleLimparCampos}
                                            {...a11yProps(5)}
                                        />
                                    </Tabs>
                                </Box>
                                <TabPanel value={value} index={0}>
                                    <Grid container size={{ xs: 12, sm: 12 }} spacing={2}>
                                        {(!removeLoading || isLoading) && <Loading />}
                                        <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                            <Typography variant="h6">Conferências</Typography>
                                            <hr />
                                        </Grid>

                                        <Grid container size={{ xs: 12, sm: 12, md: 6 }} spacing={2}>
                                            <Grid size={{ xs: 12, sm: 12, md: 6 }} >
                                                <TextField
                                                    fullWidth
                                                    name="conferencia1"
                                                    disabled={edicao && isLoading}
                                                    label="Conferência 1"
                                                    value={conferencia1}
                                                    onChange={(e) => { setConferencia1(e.target.value); setAtualizarConferencia(true); }}
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        },
                                                        htmlInput: {
                                                            maxLength: 20
                                                        }
                                                    }}
                                                />
                                                <TextField
                                                    type="number"
                                                    name="codigo_Conferencia1"
                                                    disabled={isLoading}
                                                    label="Código Divisão 8"
                                                    value={codigo_Conferencia1}
                                                    onChange={(e) => { setCodigo_Conferencia1(Number(e.target.value)); setAtualizarConferencia(true); }}
                                                    sx={{ display: "none" }}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container size={{ xs: 12, sm: 12, md: 6 }} spacing={2} >
                                            <Grid size={{ xs: 12, sm: 12, md: 6 }} >
                                                <TextField
                                                    fullWidth
                                                    name="conferencia2"
                                                    disabled={isLoading}
                                                    label="Conferência 2"
                                                    value={conferencia2}
                                                    onChange={(e) => { setConferencia2(e.target.value); setAtualizarConferencia(true); }}
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        }
                                                        ,
                                                        htmlInput: {
                                                            maxLength: 20
                                                        }
                                                    }}

                                                />
                                                <TextField
                                                    type="number"
                                                    name="codigo_Conferencia2"
                                                    disabled={isLoading}
                                                    label="Código Divisão 8"
                                                    value={codigo_Conferencia2}
                                                    onChange={(e) => { setCodigo_Conferencia2(Number(e.target.value)); setAtualizarConferencia(true); }}
                                                    sx={{ display: "none" }}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container size={{ xs: 12, sm: 12, md: 6 }} spacing={2}>
                                            <Grid size={{ xs: 12, sm: 12, md: 6 }} >
                                                <TextField
                                                    fullWidth
                                                    name="conf1_divisao1"
                                                    disabled={isLoading}
                                                    label="Divisão 1"
                                                    value={conf1_divisao1}
                                                    onChange={(e) => { setDivisao1(e.target.value); setAtualizarConferencia(true); }}
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        },
                                                        htmlInput: {
                                                            maxLength: 20
                                                        }
                                                    }}
                                                />
                                                <TextField
                                                    type="number"
                                                    name="codigo_conf1_divisao1"
                                                    disabled={isLoading}
                                                    label="Código Divisão 1"
                                                    value={codigo_conf1_divisao1}
                                                    onChange={(e) => { setCodigo_conf1_divisao1(Number(e.target.value)); setAtualizarConferencia(true); }}
                                                    sx={{ display: "none" }}
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 6 }} >
                                                <TextField
                                                    fullWidth
                                                    name="conf1_divisao2"
                                                    disabled={isLoading}
                                                    label="Divisão 2"
                                                    value={conf1_divisao2}
                                                    onChange={(e) => { setDivisao2(e.target.value); setAtualizarConferencia(true); }}
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        },
                                                        htmlInput: {
                                                            maxLength: 20
                                                        }
                                                    }}

                                                />
                                                <TextField
                                                    type="number"
                                                    name="codigo_conf1_divisao2"
                                                    disabled={isLoading}
                                                    label="Código Divisão 2"
                                                    value={codigo_conf1_divisao2}
                                                    onChange={(e) => { setCodigo_conf1_divisao2(Number(e.target.value)); setAtualizarConferencia(true); }}
                                                    sx={{ display: "none" }}
                                                />
                                            </Grid>
                                            {divisaoDupla && divisaoTripla && !divisaoQuadrupla && (<Grid size={{ xs: 12, sm: 12, md: 6 }} >
                                                <TextField
                                                    fullWidth
                                                    name="conf1_divisao3"
                                                    disabled={isLoading}
                                                    label="Divisão 3"
                                                    value={conf1_divisao3}
                                                    onChange={(e) => { setDivisao3(e.target.value); setAtualizarConferencia(true); }}
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        },
                                                        htmlInput: {
                                                            maxLength: 20
                                                        }
                                                    }}

                                                />
                                                <TextField
                                                    type="number"
                                                    name="codigo_conf1_divisao3"
                                                    disabled={isLoading}
                                                    label="Código Divisão 3"
                                                    value={codigo_conf1_divisao3}
                                                    onChange={(e) => { setCodigo_conf1_divisao3(Number(e.target.value)); setAtualizarConferencia(true); }}
                                                    sx={{ display: "none" }}
                                                />
                                            </Grid>
                                            )}
                                            {divisaoDupla && divisaoTripla && divisaoQuadrupla && (<Grid size={{ xs: 12, sm: 12, md: 6 }} >
                                                <TextField
                                                    fullWidth
                                                    name="conf1_divisao4"
                                                    disabled={isLoading}
                                                    label="Divisão 4"
                                                    value={conf1_divisao4}
                                                    onChange={(e) => { setDivisao4(e.target.value); setAtualizarConferencia(true); }}
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        },
                                                        htmlInput: {
                                                            maxLength: 20
                                                        }
                                                    }}
                                                />
                                                <TextField
                                                    type="number"
                                                    name="codigo_conf1_divisao4"
                                                    disabled={isLoading}
                                                    label="Código Divisão 4"
                                                    value={codigo_conf1_divisao4}
                                                    onChange={(e) => { setCodigo_conf1_divisao4(Number(e.target.value)); setAtualizarConferencia(true); }}
                                                    sx={{ display: "none" }}
                                                />
                                            </Grid>
                                            )}
                                        </Grid>
                                        <Grid container size={{ xs: 12, sm: 12, md: 6 }} spacing={2}>
                                            <Grid size={{ xs: 12, sm: 12, md: 6 }} >
                                                <TextField
                                                    fullWidth
                                                    name="conf2_divisao1"
                                                    disabled={isLoading}
                                                    label="Divisão 5"
                                                    value={conf2_divisao1}
                                                    onChange={(e) => { setDivisao5(e.target.value); setAtualizarConferencia(true); }}
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        },
                                                        htmlInput: {
                                                            maxLength: 20
                                                        }
                                                    }}
                                                />
                                                <TextField
                                                    type="number"
                                                    name="codigo_conf2_divisao1"
                                                    disabled={isLoading}
                                                    label="Código Divisão 5"
                                                    value={codigo_conf2_divisao1}
                                                    onChange={(e) => setCodigo_conf2_divisao1(Number(e.target.value))}
                                                    sx={{ display: "none" }}
                                                />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 12, md: 6 }} >
                                                <TextField
                                                    fullWidth
                                                    name="conf2_divisao2"
                                                    disabled={isLoading}
                                                    label="Divisão 6"
                                                    value={conf2_divisao2}
                                                    onChange={(e) => { setDivisao6(e.target.value); setAtualizarConferencia(true); }}
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        },
                                                        htmlInput: {
                                                            maxLength: 20
                                                        }
                                                    }}

                                                />
                                                <TextField
                                                    type="number"
                                                    name="codigo_conf2_divisao2"
                                                    disabled={isLoading}
                                                    label="Código Divisão 6"
                                                    value={codigo_conf2_divisao2}
                                                    onChange={(e) => setCodigo_conf2_divisao2(Number(e.target.value))}
                                                    sx={{ display: "none" }}
                                                />
                                            </Grid>
                                            {divisaoDupla && divisaoTripla && !divisaoQuadrupla && (<Grid size={{ xs: 12, sm: 12, md: 6 }} >
                                                <TextField
                                                    fullWidth
                                                    name="conf2_divisao3"
                                                    disabled={isLoading}
                                                    label="Divisão 7"
                                                    value={conf2_divisao3}
                                                    onChange={(e) => { setDivisao7(e.target.value); setAtualizarConferencia(true); }}
                                                    slotProps={{
                                                        inputLabel: {
                                                            shrink: edicao ? true : undefined,
                                                        },
                                                        htmlInput: {
                                                            maxLength: 20
                                                        }
                                                    }}

                                                />
                                                <TextField
                                                    type="number"
                                                    name="codigo_conf2_divisao3"
                                                    disabled={isLoading}
                                                    label="Código Divisão 7"
                                                    value={codigo_conf2_divisao3}
                                                    onChange={(e) => setCodigo_conf2_divisao3(Number(e.target.value))}
                                                    sx={{ display: "none" }}
                                                />
                                            </Grid>
                                            )}
                                            {divisaoDupla && divisaoTripla && divisaoQuadrupla && (
                                                <Grid size={{ xs: 12, sm: 12, md: 6 }} >
                                                    <TextField
                                                        fullWidth
                                                        name="conf2_divisao4"
                                                        disabled={isLoading}
                                                        label="Divisão 8"
                                                        value={conf2_divisao4}
                                                        onChange={(e) => { setDivisao8(e.target.value); setAtualizarConferencia(true); }}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            },
                                                            htmlInput: {
                                                                maxLength: 20
                                                            }
                                                        }}

                                                    />
                                                    <TextField
                                                        type="number"
                                                        name="codigo_conf2_divisao4"
                                                        disabled={isLoading}
                                                        label="Código Divisão 8"
                                                        value={codigo_conf2_divisao4}
                                                        onChange={(e) => setCodigo_conf2_divisao4(Number(e.target.value))}
                                                    // sx={{display: "none"}}
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                        {liberarEdicao && (<>
                                            <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                <Typography variant="h6">Franquias</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                                                <FormControl>
                                                    <FormLabel>Tipo</FormLabel>
                                                    <MuiRadioGroup
                                                        row
                                                        name="tipo"
                                                        value={tipo}
                                                        onChange={(e) => {
                                                            handleChangeTipoFranquia(e);
                                                        }}
                                                    >
                                                        {
                                                            TipoSorteioFranquias.map(item => (<FormControlLabel key={item.codigo} value={item.codigo} control={<Radio />} label={item.label} />))
                                                        }
                                                    </MuiRadioGroup>
                                                </FormControl >
                                            </Grid>
                                        </>)}
                                        {liberarEdicao && (
                                            <Grid container size={{ xs: 12, sm: 12 }} display="flex">
                                                <Grid container size={{ xs: 12, sm: 12 }} display={tipo === 1 ? "flex" : "none"}>
                                                    <Scope path="liberacoes_Liga" >
                                                        <Grid size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
                                                            <VTextFieldDatas
                                                                fullWidth
                                                                required
                                                                type="datetime-local"
                                                                name="data_Sorteio_Franquia"
                                                                disabled={isLoading}
                                                                label="Sorteio Franquias"
                                                                slotProps={{
                                                                    inputLabel: {
                                                                        shrink: edicao ? true : undefined,
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                    </Scope>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }} display={fraquiasCriadas ? "flex" : "none"} spacing={1} >
                                                    <Grid container size={{ xs: 12, sm: 6 }} padding={1} >
                                                        <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                            <Typography variant="h6">Conferência 1</Typography>
                                                            <hr />
                                                        </Grid>
                                                        <Grid container size={{ xs: 12, sm: 12 }} marginTop={2}>
                                                            <Grid size={{ xs: 12, sm: 12 }} padding={1}><Typography variant="h6">{conf1_divisao1}</Typography></Grid>
                                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                                <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                                    <Table>
                                                                        <TableHead>
                                                                            <StyledTableRow>
                                                                                {/* <StyledTableCell width={60}>Ações</StyledTableCell> */}
                                                                                <StyledTableCell>Conferência</StyledTableCell>
                                                                                <StyledTableCell>Divisão</StyledTableCell>
                                                                                <StyledTableCell align="center" width={130}>Franquia</StyledTableCell>
                                                                            </StyledTableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {divisao1FranquiasRows.map((row, index) => (
                                                                                <StyledTableRow key={index}>
                                                                                    {/* <StyledTableCell>
                                                                                        <IconButton size="small" onClick={() => deleteFranquia1(index)}>
                                                                                            <Icon>delete</Icon>
                                                                                        </IconButton>
                                                                                    </StyledTableCell> */}
                                                                                    <StyledTableCell>{`${row.nome_Conferencia} (${row.codigo_Franquia}) `}</StyledTableCell>
                                                                                    <StyledTableCell>{row.nome_Divisao}</StyledTableCell>
                                                                                    <StyledTableCell>
                                                                                        <FormControl fullWidth disabled={isLoading}>
                                                                                            <Select
                                                                                                variant="standard"
                                                                                                name={`dropFranquia1${index}`}
                                                                                                value={eval(`dropFranquia1${index}`)}
                                                                                                label=""
                                                                                                onChange={(e) => { verificarFranquiasDropEscolhida(e, index, 1, 1); }}
                                                                                                defaultValue={row.codigo_Franquia || 0}
                                                                                            >
                                                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                                                {
                                                                                                    lstFranquia.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                                                }
                                                                                            </Select>
                                                                                        </FormControl>
                                                                                    </StyledTableCell>
                                                                                </StyledTableRow>
                                                                            ))
                                                                            }
                                                                        </TableBody>
                                                                        <TableFooter>
                                                                            {isLoading && (
                                                                                <StyledTableRow>
                                                                                    <StyledTableCell colSpan={5}>
                                                                                        <LinearProgress variant="indeterminate" />
                                                                                    </StyledTableCell>
                                                                                </StyledTableRow>
                                                                            )}

                                                                        </TableFooter>
                                                                    </Table>
                                                                </TableContainer>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container size={{ xs: 12, sm: 12 }} marginTop={2}>
                                                            <Grid size={{ xs: 12, sm: 12 }} padding={1}><Typography variant="h6">{conf1_divisao2}</Typography></Grid>
                                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                                <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                                    <Table>
                                                                        <TableHead>
                                                                            <StyledTableRow>
                                                                                {/* <StyledTableCell width={100}>Ações</StyledTableCell> */}
                                                                                <StyledTableCell>Conferência</StyledTableCell>
                                                                                <StyledTableCell>Divisão</StyledTableCell>
                                                                                <StyledTableCell align="center" width={130}>Franquia</StyledTableCell>
                                                                            </StyledTableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {divisao2FranquiasRows.map((row, index) => (
                                                                                <StyledTableRow key={index}>
                                                                                    {/* <StyledTableCell>
                                                                                        <IconButton size="small" onClick={() => deleteFranquia2(index)}>
                                                                                            <Icon>delete</Icon>
                                                                                        </IconButton>
                                                                                    </StyledTableCell> */}
                                                                                    <StyledTableCell>{`${row.nome_Conferencia} (${row.codigo_Franquia}) `}</StyledTableCell>
                                                                                    <StyledTableCell>{row.nome_Divisao}</StyledTableCell>
                                                                                    <StyledTableCell>
                                                                                        <FormControl fullWidth disabled={isLoading}>
                                                                                            <Select
                                                                                                variant="standard"
                                                                                                name={`dropFranquia2${index}`}
                                                                                                value={eval(`dropFranquia2${index}`)}
                                                                                                label=""
                                                                                                onChange={(e) => { setShowModalMensagem(false); verificarFranquiasDropEscolhida(e, index, 2, 1); }}
                                                                                                defaultValue={row.codigo_Divisao || 0}
                                                                                            >
                                                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                                                {
                                                                                                    lstFranquia.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                                                }

                                                                                            </Select>
                                                                                        </FormControl >

                                                                                    </StyledTableCell>
                                                                                </StyledTableRow>
                                                                            ))
                                                                            }
                                                                        </TableBody>
                                                                        <TableFooter>
                                                                            {isLoading && (
                                                                                <StyledTableRow>
                                                                                    <StyledTableCell colSpan={5}>
                                                                                        <LinearProgress variant="indeterminate" />
                                                                                    </StyledTableCell>
                                                                                </StyledTableRow>
                                                                            )}
                                                                        </TableFooter>
                                                                    </Table>
                                                                </TableContainer>
                                                            </Grid>
                                                        </Grid>
                                                        {divisaoDupla && divisaoTripla && !divisaoQuadrupla && (
                                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={2}>
                                                                <Grid size={{ xs: 12, sm: 12 }} padding={1}><Typography variant="h6">{conf1_divisao3}</Typography></Grid>
                                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                                    <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                                        <Table>
                                                                            <TableHead>
                                                                                <StyledTableRow>
                                                                                    {/* <StyledTableCell width={100}>Ações</StyledTableCell> */}
                                                                                    <StyledTableCell>Conferência</StyledTableCell>
                                                                                    <StyledTableCell>Divisão</StyledTableCell>
                                                                                    <StyledTableCell align="center" width={130}>Franquia</StyledTableCell>
                                                                                </StyledTableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {divisao3FranquiasRows.map((row, index) => (
                                                                                    <StyledTableRow key={index}>
                                                                                        {/* <StyledTableCell>
                                                                                            <IconButton size="small" onClick={() => deleteFranquia3(index)}>
                                                                                                <Icon>delete</Icon>
                                                                                            </IconButton>
                                                                                        </StyledTableCell> */}
                                                                                        <StyledTableCell>{`${row.nome_Conferencia} (${row.codigo_Franquia}) `}</StyledTableCell>
                                                                                        <StyledTableCell>{row.nome_Divisao}</StyledTableCell>
                                                                                        <StyledTableCell >
                                                                                            <FormControl fullWidth disabled={isLoading}>
                                                                                                <Select
                                                                                                    variant="standard"
                                                                                                    name={`dropFranquia3${index}`}
                                                                                                    value={eval(`dropFranquia3${index}`)}
                                                                                                    label=""
                                                                                                    onChange={(e) => { setShowModalMensagem(false); verificarFranquiasDropEscolhida(e, index, 3, 1); }}
                                                                                                >
                                                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                                                    {
                                                                                                        lstFranquia.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                                                    }

                                                                                                </Select>
                                                                                            </FormControl >

                                                                                        </StyledTableCell>
                                                                                    </StyledTableRow>
                                                                                ))
                                                                                }
                                                                            </TableBody>
                                                                            <TableFooter>
                                                                                {isLoading && (
                                                                                    <StyledTableRow>
                                                                                        <StyledTableCell colSpan={5}>
                                                                                            <LinearProgress variant="indeterminate" />
                                                                                        </StyledTableCell>
                                                                                    </StyledTableRow>
                                                                                )}
                                                                            </TableFooter>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </Grid>
                                                            </Grid>

                                                        )}
                                                        {divisaoDupla && divisaoTripla && divisaoQuadrupla && (
                                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={2}>
                                                                <Grid size={{ xs: 12, sm: 12 }} padding={1}><Typography variant="h6">{conf1_divisao4}</Typography></Grid>
                                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                                    <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                                        <Table>
                                                                            <TableHead>
                                                                                <StyledTableRow>
                                                                                    {/* <StyledTableCell width={100}>Ações</StyledTableCell> */}
                                                                                    <StyledTableCell>Conferência</StyledTableCell>
                                                                                    <StyledTableCell>Divisão</StyledTableCell>
                                                                                    <StyledTableCell align="center" width={130}>Franquia</StyledTableCell>
                                                                                </StyledTableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {divisao4FranquiasRows.map((row, index) => (
                                                                                    <StyledTableRow key={index}>
                                                                                        {/* <StyledTableCell>
                                                                                            <IconButton size="small" onClick={() => deleteFranquia4(index)}>
                                                                                                <Icon>delete</Icon>
                                                                                            </IconButton>
                                                                                        </StyledTableCell> */}
                                                                                        <StyledTableCell>{`${row.nome_Conferencia} (${row.codigo_Franquia}) `}</StyledTableCell>
                                                                                        <StyledTableCell>{row.nome_Divisao}</StyledTableCell>
                                                                                        <StyledTableCell >
                                                                                            <FormControl fullWidth disabled={isLoading}>
                                                                                                <Select
                                                                                                    variant="standard"
                                                                                                    name={`dropFranquia4${index}`}
                                                                                                    value={eval(`dropFranquia4${index}`)}
                                                                                                    label=""
                                                                                                    onChange={(e) => { setShowModalMensagem(false); verificarFranquiasDropEscolhida(e, index, 4, 1); }}
                                                                                                >
                                                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                                                    {
                                                                                                        lstFranquia.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                                                    }

                                                                                                </Select>
                                                                                            </FormControl >

                                                                                        </StyledTableCell>
                                                                                    </StyledTableRow>
                                                                                ))
                                                                                }
                                                                            </TableBody>
                                                                            <TableFooter>
                                                                                {isLoading && (
                                                                                    <StyledTableRow>
                                                                                        <StyledTableCell colSpan={7}>
                                                                                            <LinearProgress variant="indeterminate" />
                                                                                        </StyledTableCell>
                                                                                    </StyledTableRow>
                                                                                )}
                                                                            </TableFooter>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </Grid>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                    <Grid container size={{ xs: 12, sm: 6 }} padding={1} >
                                                        <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                            <Typography variant="h6">Conferência 2</Typography>
                                                            <hr />
                                                        </Grid>
                                                        <Grid container size={{ xs: 12, sm: 12 }} marginTop={2}>
                                                            <Grid size={{ xs: 12, sm: 12 }} padding={1}><Typography variant="h6">{conf2_divisao1}</Typography></Grid>
                                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                                <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                                    <Table>
                                                                        <TableHead>
                                                                            <StyledTableRow>
                                                                                {/* <StyledTableCell width={100}>Ações</StyledTableCell> */}
                                                                                <StyledTableCell>Conferência</StyledTableCell>
                                                                                <StyledTableCell>Divisão</StyledTableCell>
                                                                                <StyledTableCell align="center" width={130}>Franquia</StyledTableCell>
                                                                            </StyledTableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {divisao5FranquiasRows.map((row, index) => (
                                                                                <StyledTableRow key={index}>
                                                                                    {/* <StyledTableCell>
                                                                                        <IconButton size="small" onClick={() => deleteFranquia5(index)}>
                                                                                            <Icon>delete</Icon>
                                                                                        </IconButton>
                                                                                    </StyledTableCell> */}
                                                                                    <StyledTableCell>{`${row.nome_Conferencia} (${row.codigo_Franquia}) `}</StyledTableCell>
                                                                                    <StyledTableCell>{row.nome_Divisao}</StyledTableCell>
                                                                                    <StyledTableCell >
                                                                                        <FormControl fullWidth disabled={isLoading}>
                                                                                            <Select
                                                                                                variant="standard"
                                                                                                name={`dropFranquia5${index}`}
                                                                                                value={eval(`dropFranquia5${index}`)}
                                                                                                label=""
                                                                                                onChange={(e) => verificarFranquiasDropEscolhida(e, index, 1, 2)}
                                                                                            >
                                                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                                                {
                                                                                                    lstFranquia.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                                                }

                                                                                            </Select>
                                                                                        </FormControl >

                                                                                    </StyledTableCell>
                                                                                </StyledTableRow>
                                                                            ))
                                                                            }
                                                                        </TableBody>
                                                                        <TableFooter>
                                                                            {isLoading && (
                                                                                <StyledTableRow>
                                                                                    <StyledTableCell colSpan={5}>
                                                                                        <LinearProgress variant="indeterminate" />
                                                                                    </StyledTableCell>
                                                                                </StyledTableRow>
                                                                            )}
                                                                        </TableFooter>
                                                                    </Table>
                                                                </TableContainer>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid container size={{ xs: 12, sm: 12 }} marginTop={2}>
                                                            <Grid size={{ xs: 12, sm: 12 }} padding={1}><Typography variant="h6">{conf2_divisao2}</Typography></Grid>
                                                            <Grid size={{ xs: 12, sm: 12 }} >
                                                                <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                                    <Table>
                                                                        <TableHead>
                                                                            <StyledTableRow>
                                                                                {/* <StyledTableCell width={100}>Ações</StyledTableCell> */}
                                                                                <StyledTableCell>Conferência</StyledTableCell>
                                                                                <StyledTableCell>Divisão</StyledTableCell>
                                                                                <StyledTableCell align="center" width={130}>Franquia</StyledTableCell>
                                                                            </StyledTableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {divisao6FranquiasRows.map((row, index) => (
                                                                                <StyledTableRow key={index}>
                                                                                    {/* <StyledTableCell>
                                                                                        <IconButton size="small" onClick={() => deleteFranquia6(index)}>
                                                                                            <Icon>delete</Icon>
                                                                                        </IconButton>
                                                                                    </StyledTableCell> */}
                                                                                    <StyledTableCell>{`${row.nome_Conferencia} (${row.codigo_Franquia}) `}</StyledTableCell>
                                                                                    <StyledTableCell>{row.nome_Divisao}</StyledTableCell>
                                                                                    <StyledTableCell >
                                                                                        <FormControl fullWidth disabled={isLoading}>
                                                                                            <Select
                                                                                                variant="standard"
                                                                                                name={`dropFranquia6${index}`}
                                                                                                value={eval(`dropFranquia6${index}`)}
                                                                                                label=""
                                                                                                onChange={(e) => verificarFranquiasDropEscolhida(e, index, 2, 2)}
                                                                                            >
                                                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                                                {
                                                                                                    lstFranquia.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                                                }

                                                                                            </Select>
                                                                                        </FormControl >

                                                                                    </StyledTableCell>
                                                                                </StyledTableRow>
                                                                            ))
                                                                            }
                                                                        </TableBody>
                                                                        <TableFooter>
                                                                            {isLoading && (
                                                                                <StyledTableRow>
                                                                                    <StyledTableCell colSpan={5}>
                                                                                        <LinearProgress variant="indeterminate" />
                                                                                    </StyledTableCell>
                                                                                </StyledTableRow>
                                                                            )}
                                                                        </TableFooter>
                                                                    </Table>
                                                                </TableContainer>
                                                            </Grid>
                                                        </Grid>
                                                        {divisaoDupla && divisaoTripla && !divisaoQuadrupla && (
                                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={2}>
                                                                <Grid size={{ xs: 12, sm: 12 }} padding={1}><Typography variant="h6">{conf2_divisao3}</Typography></Grid>
                                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                                    <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                                        <Table>
                                                                            <TableHead>
                                                                                <StyledTableRow>
                                                                                    {/* <StyledTableCell width={100}>Ações</StyledTableCell> */}
                                                                                    <StyledTableCell>Conferência</StyledTableCell>
                                                                                    <StyledTableCell>Divisão</StyledTableCell>
                                                                                    <StyledTableCell align="center" width={130}>Franquia</StyledTableCell>
                                                                                </StyledTableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {divisao7FranquiasRows.map((row, index) => (
                                                                                    <StyledTableRow key={index}>
                                                                                        {/* <StyledTableCell>
                                                                                            <IconButton size="small" onClick={() => deleteFranquia7(index)}>
                                                                                                <Icon>delete</Icon>
                                                                                            </IconButton>
                                                                                        </StyledTableCell> */}
                                                                                        <StyledTableCell>{`${row.nome_Conferencia} (${row.codigo_Franquia}) `}</StyledTableCell>
                                                                                        <StyledTableCell>{row.nome_Divisao}</StyledTableCell>
                                                                                        <StyledTableCell >
                                                                                            <FormControl fullWidth disabled={isLoading}>
                                                                                                <Select
                                                                                                    variant="standard"
                                                                                                    name={`dropFranquia7${index}`}
                                                                                                    value={eval(`dropFranquia7${index}`)}
                                                                                                    label=""
                                                                                                    onChange={(e) => verificarFranquiasDropEscolhida(e, index, 3, 2)}
                                                                                                >
                                                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                                                    {
                                                                                                        lstFranquia.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                                                    }

                                                                                                </Select>
                                                                                            </FormControl >

                                                                                        </StyledTableCell>
                                                                                    </StyledTableRow>
                                                                                ))
                                                                                }
                                                                            </TableBody>
                                                                            <TableFooter>
                                                                                {isLoading && (
                                                                                    <StyledTableRow>
                                                                                        <StyledTableCell colSpan={5}>
                                                                                            <LinearProgress variant="indeterminate" />
                                                                                        </StyledTableCell>
                                                                                    </StyledTableRow>
                                                                                )}
                                                                            </TableFooter>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </Grid>
                                                            </Grid>
                                                        )}
                                                        {divisaoDupla && divisaoTripla && divisaoQuadrupla && (
                                                            <Grid container size={{ xs: 12, sm: 12 }} marginTop={2}>
                                                                <Grid size={{ xs: 12, sm: 12 }} padding={1}><Typography variant="h6">{conf2_divisao4}</Typography></Grid>
                                                                <Grid size={{ xs: 12, sm: 12 }} >
                                                                    <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                                        <Table>
                                                                            <TableHead>
                                                                                <StyledTableRow>
                                                                                    {/* <StyledTableCell width={100}>Ações</StyledTableCell> */}
                                                                                    <StyledTableCell>Conferência</StyledTableCell>
                                                                                    <StyledTableCell>Divisão</StyledTableCell>
                                                                                    <StyledTableCell width={130}>Franquia</StyledTableCell>
                                                                                </StyledTableRow>
                                                                            </TableHead>
                                                                            <TableBody>
                                                                                {divisao8FranquiasRows.map((row, index) => (
                                                                                    <StyledTableRow key={index}>
                                                                                        {/* <StyledTableCell>
                                                                                            <IconButton size="small" onClick={() => deleteFranquia8(index)}>
                                                                                                <Icon>delete</Icon>
                                                                                            </IconButton>
                                                                                        </StyledTableCell> */}
                                                                                        <StyledTableCell>{`${row.nome_Conferencia} (${row.codigo_Franquia}) `}</StyledTableCell>
                                                                                        <StyledTableCell>{row.nome_Divisao}</StyledTableCell>
                                                                                        <StyledTableCell >
                                                                                            <FormControl fullWidth disabled={isLoading}>
                                                                                                <Select
                                                                                                    variant="standard"
                                                                                                    name={`dropFranquia8${index}`}
                                                                                                    value={eval(`dropFranquia8${index}`)}
                                                                                                    label=""
                                                                                                    onChange={(e) => verificarFranquiasDropEscolhida(e, index, 4, 2)}
                                                                                                >
                                                                                                    <MenuItem value={0}>Selecione</MenuItem>
                                                                                                    {
                                                                                                        lstFranquia.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                                                    }

                                                                                                </Select>
                                                                                            </FormControl >

                                                                                        </StyledTableCell>
                                                                                    </StyledTableRow>
                                                                                ))
                                                                                }
                                                                            </TableBody>
                                                                            <TableFooter>
                                                                                {isLoading && (
                                                                                    <StyledTableRow>
                                                                                        <StyledTableCell colSpan={5}>
                                                                                            <LinearProgress variant="indeterminate" />
                                                                                        </StyledTableCell>
                                                                                    </StyledTableRow>
                                                                                )}
                                                                            </TableFooter>
                                                                        </Table>
                                                                    </TableContainer>
                                                                </Grid>
                                                            </Grid>
                                                        )}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={1}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={{ xs: 12, sm: 12 }} direction="column">
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex">
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6">Draft Ordem Inicial</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                                                <FormControl >
                                                    <FormLabel>Primeira Rodada</FormLabel>
                                                    <MuiRadioGroup
                                                        row
                                                        name="primeiraRodada"
                                                        value={primeiraRodada}
                                                        onChange={(e) => {
                                                            handleChangeDraftPrimeiraRodada(e);
                                                        }}
                                                    >
                                                        {
                                                            TipoSorteioFranquias.map(item => (<FormControlLabel disabled={sorteioRealizado} key={item.codigo} value={item.codigo} control={<Radio />} label={item.label} />))
                                                        }
                                                    </MuiRadioGroup>
                                                </FormControl >
                                            </Grid>
                                            {!showSorteio && (<Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    disableElevation
                                                    onClick={LimarDropsInicial}
                                                    startIcon={<Icon>change_circle</Icon>}
                                                >
                                                    Limpar Todos
                                                </Button>
                                            </Grid>
                                            )}
                                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" >
                                                {showSorteio && (
                                                    <Grid container size={{ xs: 12, sm: 12 }} spacing={2}>
                                                        <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                disableElevation
                                                                onClick={handleRealizarSorteioInicial}
                                                                startIcon={<Icon>check</Icon>}
                                                                disabled={sorteioRealizado || !usuarioComissario}
                                                            >
                                                                Sortear Draft Inicial
                                                            </Button>
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 3, md: 3 }} >
                                                            <Button
                                                                color="primary"
                                                                variant="contained"
                                                                disableElevation
                                                                onClick={(_) => CarregarDadosSorteioInicial()}
                                                                startIcon={<Icon>cached</Icon>}
                                                                disabled={sorteioFinalizado || !usuarioComissario}
                                                            >
                                                                RECARREGAR
                                                            </Button>
                                                        </Grid>
                                                        <Grid size={{ xs: 12, sm: 5, md: 6 }} >
                                                            {sorteioRealizado && !sorteioFinalizado &&
                                                                <>
                                                                    {UseCountdown(dataUltimoSorteio, sorteioRealizado)}
                                                                </>
                                                            }
                                                        </Grid>
                                                    </Grid>
                                                )}
                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                    <hr />
                                                </Grid>
                                                {!showSorteio ? (
                                                    <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display={exibirDados ? "flex" : "none"}>
                                                        {lstEscolhas.map((m, i) => (
                                                            <Grid container size={{ xs: 12, sm: 12 }}>
                                                                <Grid size={{ xs: 12, sm: 6, md: 2 }} display="flex" alignSelf="center" justifyContent="center">
                                                                    <Typography variant="h6">ESCOLHA: {m.escolha_Inicial !== 0 ? m.escolha_Inicial : (i + 1)}</Typography>
                                                                </Grid>
                                                                <Grid size={{ xs: 12, sm: 6, md: 4 }} padding={2}>
                                                                    <FormControl fullWidth disabled={isLoading}>
                                                                        <Select
                                                                            variant="outlined"
                                                                            name={`franquiaSelecionada${m.escolha_Inicial !== 0 ? m.escolha_Inicial : (i + 1)}`}
                                                                            value={eval(`franquiaSelecionada${m.escolha_Inicial !== 0 ? m.escolha_Inicial : (i + 1)}`)}
                                                                            label=""
                                                                            onChange={(e) => handleFranquiaSelecionada(Number(e.target.value), m.escolha_Inicial !== 0 ? m.escolha_Inicial : (i + 1))}
                                                                        >
                                                                            <MenuItem value={0}>Selecione</MenuItem>
                                                                            {
                                                                                lstFranquia.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                            }
                                                                        </Select>
                                                                    </FormControl >
                                                                </Grid>
                                                                <Grid size={{ xs: 12, sm: 6, md: 6 }} display="flex" alignSelf="center" justifyContent="start">
                                                                    <Typography variant="h6">ESCOLHAS: {m.posicao_Geral}</Typography>
                                                                </Grid>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                ) : (
                                                    rowsSorteioPicks.length > 0 &&
                                                    <>
                                                        <Grid container size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                            <Grid size={{ xs: 12 }} paddingTop={2}>
                                                                <Typography variant="h6">FRANQUIAS POR POSIÇÃO</Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <hr />
                                                            </Grid>
                                                        </Grid>
                                                        <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined" width={"100%"}>
                                                            <Grid container direction="column" padding={2} spacing={3} marginLeft={"-16px"} marginTop={"-16px"}>
                                                                <Grid container size={{ xs: 12 }} spacing={2}  >
                                                                    {rowsSorteioPicks.length > 0 && rowsSorteioPicks.map((r, i) => (
                                                                        <Card key={`Card${i}`} sx={{ border: "2px solid", borderColor: "#303134", m: UtilidadeService.isMobile() ? 0 : 1, width: UtilidadeService.isMobile() ? "48%" : "18%" }}>
                                                                            <CardContent sx={{ paddingBottom: 1, backgroundColor: "#252525", height: UtilidadeService.isMobile() ? "160px" : "175px" }} >
                                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }} direction={"column"} display="flex" justifyContent="center" textAlign="center" paddingBottom={1}>
                                                                                    <Grid size={{ xs: 12 }}>
                                                                                        <Typography variant="body1">
                                                                                            Posição: {r.posicao_Final}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                    <Grid size={{ xs: 12 }} padding={"8px"}>
                                                                                        <img src={r.logo_Franquia_Original === null ? showImagemFranquia : r.logo_Franquia_Original} alt="SrcImagem" width={UtilidadeService.isMobile() ? "70" : "100"} height={UtilidadeService.isMobile() ? "80" : "110"} />
                                                                                    </Grid>
                                                                                    <Grid size={{ xs: 12 }}>
                                                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>
                                                                                            {r.nome_Franquia_Original}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </CardContent>
                                                                        </Card>
                                                                    ))}
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    </>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={2}>
                                    {(!removeLoading || isLoading) && <Loading />}
                                    <Grid container size={{ xs: 12, sm: 12 }} direction="column">
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex">
                                            <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                <Typography variant="h6">Draft Ordem Calouro</Typography>
                                                <hr />
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 4, md: 4, lg: 4, xl: 4 }}>
                                                <CheckBox
                                                    name="escolha_Espelhada_Draft_Calouro"
                                                    isExternalLoading={isLoading}
                                                    checked={escolha_Espelhada_Draft_Calouro}
                                                    onChange={e => { handleCheckRodadaEspelhada(e) }}
                                                    label="Escolha Espelhada?"
                                                    labelPlacement="start"
                                                    disabled={!usuarioComissario && !user.administrador}
                                                />
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} display="flex" >
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={2}>
                                                    <Grid size={{ xs: 12, sm: 3, md: 3 }}>
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            disableElevation
                                                            onClick={handleRealizarSorteioCalouro}
                                                            startIcon={<Icon>check</Icon>}
                                                            disabled={(sorteioCalouroRealizado || !usuarioComissario) && !user.administrador}
                                                        >
                                                            Sortear Draft Calouro
                                                        </Button>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 3, md: 3 }} >
                                                        <Button
                                                            color="primary"
                                                            variant="contained"
                                                            disableElevation
                                                            onClick={(_) => CarregarDadosSorteioCalouro()}
                                                            startIcon={<Icon>cached</Icon>}
                                                            disabled={(!usuarioComissario || sorteioCalouroFinalizado) && !user.administrador}
                                                        >
                                                            RECARREGAR
                                                        </Button>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 5, md: 6 }} >
                                                        {sorteioCalouroRealizado && !sorteioCalouroFinalizado &&
                                                            <>
                                                                {UseCountdownCalouro(dataUltimoSorteioCalouro, sorteioCalouroRealizado)}
                                                            </>
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                    <hr />
                                                </Grid>
                                                {showSorteioCalouro && (
                                                    rowsSorteioPicksCalouro.length > 0 &&
                                                    <>
                                                        <Grid container size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                            <Grid size={{ xs: 12 }} paddingTop={4}>
                                                                <Typography variant="h6">FRANQUIAS POR POSIÇÃO</Typography>
                                                            </Grid>
                                                            <Grid size={{ xs: 12 }}>
                                                                <hr />
                                                            </Grid>
                                                        </Grid>
                                                        <Box margin={1} display="flex" flexDirection="column" component={Paper} variant="outlined" width={"100%"}>
                                                            <Grid container size={{ xs: 12, sm: 12 }} direction="column" padding={2} spacing={3} marginLeft={"-16px"} marginTop={"-16px"}>
                                                                <Grid container size={{ xs: 12 }} spacing={2}  >
                                                                    {rowsSorteioPicksCalouro.length > 0 && rowsSorteioPicksCalouro.map((r, i) => (
                                                                        <Card key={`Card${i}`} sx={{ border: "2px solid", borderColor: "#303134", m: UtilidadeService.isMobile() ? 0 : 1, width: UtilidadeService.isMobile() ? "48%" : "18%" }}>
                                                                            <CardContent sx={{ paddingBottom: 1, backgroundColor: "#252525", height: UtilidadeService.isMobile() ? "160px" : "175px" }} >
                                                                                <Grid container size={{ xs: 12, sm: 12, md: 12 }} direction={"column"} display="flex" justifyContent="center" textAlign="center" paddingBottom={1}>
                                                                                    <Grid size={{ xs: 12 }}>
                                                                                        <Typography variant="body1">
                                                                                            Posição: {r.posicao_Final}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                    <Grid size={{ xs: 12 }} padding={"8px"}>
                                                                                        <img src={r.logo_Franquia_Original === null ? showImagemFranquia : r.logo_Franquia_Original} alt="SrcImagem" width={UtilidadeService.isMobile() ? "70" : "100"} height={UtilidadeService.isMobile() ? "80" : "110"} />
                                                                                    </Grid>
                                                                                    <Grid size={{ xs: 12 }}>
                                                                                        <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>
                                                                                            {r.nome_Franquia_Original}
                                                                                        </Typography>
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </CardContent>
                                                                        </Card>
                                                                    ))}
                                                                </Grid>
                                                            </Grid>
                                                        </Box>
                                                    </>
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={3}>
                                    <Grid container size={{ xs: 12, sm: 12 }} direction="column" >
                                        {!removeLoading && <Loading />}
                                        <Scope path="free_Agency" >
                                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" >
                                                <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                    <Typography variant="h6">Free Agency</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 2 }} display="flex" justifyContent="center">
                                                    <FormControlLabel
                                                        sx={{
                                                            display: 'block',
                                                        }}
                                                        control={
                                                            <Switch
                                                                checked={openCloseFreeAgency}
                                                                onChange={handleOpenCloseFreeAgency}
                                                                name="situacao"
                                                                color="primary"
                                                            />
                                                        }
                                                        label={labelOpenCloseFA}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
                                                    <TextField
                                                        style={{ colorScheme: "auto" }}
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        name="data_Abertura"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={data_Abertura_FA}
                                                        onChange={(e) => setData_Abertura_FA(e.target.value)}
                                                        label="Início"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
                                                    <TextField
                                                        style={{ colorScheme: "auto" }}
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        name="data_Encerramento"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={data_Encerramento_FA}
                                                        onChange={(e) => setData_Encerramento_FA(e.target.value)}
                                                        label="Término"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Scope>
                                        <Scope path="configuracao_Liga" >
                                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} marginTop={1} display="flex" >
                                                <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                    <Typography variant="h6">Mercado</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 2 }} display="flex" justifyContent="center">
                                                    <FormControlLabel
                                                        sx={{
                                                            display: 'block',
                                                        }}
                                                        control={
                                                            <Switch
                                                                checked={openCloseMercado}
                                                                onChange={handleOpenCloseMercado}
                                                                name="situacao_Mercado"
                                                                color="primary"
                                                            />
                                                        }
                                                        label={labelOpenCloseME}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
                                                    <TextField
                                                        style={{ colorScheme: "auto" }}
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        name="data_Abertura_Mercado"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={data_Abertura_ME}
                                                        onChange={(e) => setData_Abertura_ME(e.target.value)}
                                                        label="Início"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
                                                    <TextField
                                                        style={{ colorScheme: "auto" }}
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        name="data_Encerramento_Mercado"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={data_Encerramento_ME}
                                                        onChange={(e) => setData_Encerramento_ME(e.target.value)}
                                                        label="Término"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} marginTop={1} display="flex" >
                                                <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                    <Typography variant="h6">Draft Inicial</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 2 }} display="flex" justifyContent="center">
                                                    <FormControlLabel
                                                        sx={{
                                                            display: 'block',
                                                        }}
                                                        control={
                                                            <Switch
                                                                checked={openCloseDraftInicial}
                                                                onChange={handleOpenCloseDraftInicial}
                                                                name="situacao_Inicial"
                                                                color="primary"
                                                            />
                                                        }
                                                        label={labelOpenCloseDAInicial}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
                                                    <TextField
                                                        style={{ colorScheme: "auto" }}
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        name="data_Abertura_Inicial"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={data_Abertura_DA}
                                                        onChange={(e) => setData_Abertura_DA(e.target.value)}
                                                        label="Início"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
                                                    <TextField
                                                        style={{ colorScheme: "auto" }}
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        name="data_Encerramento_Inicial"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={data_Encerramento_DA}
                                                        onChange={(e) => setData_Encerramento_DA(e.target.value)}
                                                        label="Término"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 2, xl: 2 }} >
                                                    <TextField
                                                        variant="outlined"
                                                        type="number"
                                                        name="tempo_Escolha_Inicial"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={tempoDuracaoInicial}
                                                        onChange={(e) => setTempoDuracaoInicial(Number(e.target.value))}
                                                        label="Tempo (Hrs)"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 2, xl: 2 }} >
                                                    <CheckBox
                                                        name="sem_Relogio_Inicial"
                                                        isExternalLoading={isLoading}
                                                        checked={semRelogioInicial}
                                                        onChange={e => setSemRelogioInicial(e.target.checked)}
                                                        label="Sem Relógio"
                                                        labelPlacement="start"
                                                    />
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 6 }} spacing={1} display="flex" >
                                                    <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                        <Typography variant="body1">Período útil Tempo (Hrs)</Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}>
                                                        <TextField
                                                            variant="outlined"
                                                            type="time"
                                                            name="periodo_Util_Inicial_Inicial"
                                                            fullWidth
                                                            disabled={isLoading}
                                                            value={periodoUtilInicialInicial}
                                                            onChange={(e) => setPeriodoUtilInicialInicial(e.target.value)}
                                                            label="Início"
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: true,
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}>
                                                        <TextField
                                                            variant="outlined"
                                                            type="time"
                                                            name="periodo_Util_Final_Inicial"
                                                            fullWidth
                                                            disabled={isLoading}
                                                            value={periodoUtilFinalInicial}
                                                            onChange={(e) => setPeriodoUtilFinalInicial(e.target.value)}
                                                            label="Fim"
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: true,
                                                                },
                                                            }}
                                                        />
                                                        {/* <VTextField
                                                            fullWidth
                                                            name=""
                                                            disabled={isLoading}
                                                            label="Fim"
                                                            type="time"
                                                            shrink={true}
                                                        /> */}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} marginTop={1} display="flex" >
                                                <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                    <Typography variant="h6">Draft Calouro</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 2 }} display="flex" justifyContent="center">
                                                    <FormControlLabel
                                                        sx={{
                                                            display: 'block',
                                                        }}
                                                        control={
                                                            <Switch
                                                                checked={openCloseDraft}
                                                                onChange={handleOpenCloseDraftCalouro}
                                                                name="situacao_Calouro"
                                                                color="primary"
                                                            />
                                                        }
                                                        label={labelOpenCloseDA}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
                                                    <TextField
                                                        style={{ colorScheme: "auto" }}
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        name="data_Abertura_Calouro"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={data_Abertura_Calouro}
                                                        onChange={(e) => setData_Abertura_Calouro(e.target.value)}
                                                        label="Início"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />

                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
                                                    <TextField
                                                        style={{ colorScheme: "auto" }}
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        name="data_Encerramento_Calouro"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={data_Encerramento_Calouro}
                                                        onChange={(e) => setData_Encerramento_Calouro(e.target.value)}
                                                        label="Término"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 2, xl: 2 }} >
                                                    <TextField
                                                        variant="outlined"
                                                        type="number"
                                                        name="tempo_Escolha_Calouro"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={tempoDuracaoCalouro}
                                                        onChange={(e) => setTempoDuracaoCalouro(Number(e.target.value))}
                                                        label="Tempo (Hrs)"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                    {/* <VInputNumber
                                                        fullWidth
                                                        name="tempo_Escolha_Calouro"
                                                        type="text"
                                                        disabled={isLoading}
                                                        label="Tempo (Hrs)"
                                                        maxLength={2}
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 2, xl: 2 }} >
                                                    <FormControl disabled={isLoading}>
                                                        <FormControlLabel
                                                            control={
                                                                <MuiCheckBox
                                                                    name="sem_Relogio_Calouro"
                                                                    checked={semRelogioCalouro}
                                                                    onChange={(e) => { setSemRelogioCalouro(e.target.checked) }}
                                                                />
                                                            }
                                                            label="Sem Relógio"
                                                            labelPlacement="start"
                                                        />
                                                    </FormControl>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 6 }} spacing={1} display="flex" >
                                                    <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                        <Typography variant="body1">Período útil Tempo (Hrs)</Typography>
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}>
                                                        <TextField
                                                            variant="outlined"
                                                            type="time"
                                                            name="periodo_Util_Inicial_Calouro"
                                                            fullWidth
                                                            disabled={isLoading}
                                                            value={periodoUtilInicialCalouro}
                                                            onChange={(e) => setPeriodoUtilInicialCalouro(e.target.value)}
                                                            label="Início"
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: true,
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}>
                                                        <TextField
                                                            variant="outlined"
                                                            type="time"
                                                            name="periodo_Util_Final_Calouro"
                                                            fullWidth
                                                            disabled={isLoading}
                                                            value={periodoUtilFinalCalouro}
                                                            onChange={(e) => setPeriodoUtilFinalCalouro(e.target.value)}
                                                            label="Fim"
                                                            slotProps={{
                                                                inputLabel: {
                                                                    shrink: true,
                                                                },
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" >
                                                <Grid size={{ xs: 12, sm: 12 }} padding={1} marginTop={2} >
                                                    <Typography variant="h6">Troca Posição</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 2 }} display="flex" justifyContent="center">
                                                    <FormControlLabel
                                                        sx={{
                                                            display: 'block',
                                                        }}
                                                        control={
                                                            <Switch
                                                                checked={openCloseTrocaPosicao}
                                                                onChange={handleOpenCloseTrocaPosicao}
                                                                name="situacao_Troca_Posicao"
                                                                color="primary"
                                                            />
                                                        }
                                                        label={labelOpenCloseTrocaPosicao}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
                                                    <TextField
                                                        style={{ colorScheme: "auto" }}
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        name="data_Abertura_Troca_Posicao"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={data_Abertura_TP}
                                                        onChange={(e) => setData_Abertura_TP(e.target.value)}
                                                        label="Início"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                    {/* <VTextFieldDatas
                                                        fullWidth
                                                        type="datetime-local"
                                                        name="data_Abertura_Troca_Posicao"
                                                        disabled={isLoading}
                                                        label="Início"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: edicao ? true : undefined,
                                                            }
                                                        }}
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 6, lg: 3, xl: 3 }}>
                                                    <TextField
                                                        style={{ colorScheme: "auto" }}
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        name="data_Encerramento_Troca_Posicao"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={data_Encerramento_TP}
                                                        onChange={(e) => setData_Encerramento_TP(e.target.value)}
                                                        label="Término"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Scope>
                                        <Scope path="leilao" >
                                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} marginTop={1} display="flex" >
                                                <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                                    <Typography variant="h6">Leilão</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 2 }} display="flex" justifyContent="center">
                                                    <FormControlLabel
                                                        sx={{
                                                            display: 'block',
                                                        }}
                                                        control={
                                                            <Switch
                                                                checked={openCloseLeilao}
                                                                onChange={handleOpenCloseLeilao}
                                                                name="situacao"
                                                                color="primary"
                                                            />
                                                        }
                                                        label={labelOpenCloseLeilao}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <TextField
                                                        style={{ colorScheme: "auto" }}
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        name="data_Abertura"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={data_Abertura_LE}
                                                        onChange={(e) => setData_Abertura_LE(e.target.value)}
                                                        label="Leilão"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 6, md: 3 }} >
                                                    <TextField
                                                        style={{ colorScheme: "auto" }}
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        name="data_Encerramento"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={data_Encerramento_LE}
                                                        onChange={(e) => setData_Encerramento_LE(e.target.value)}
                                                        label="Término"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 2 }} >
                                                    <FormControl fullWidth>
                                                        <InputLabel id="demo-simple-select-label">Fechamento</InputLabel>
                                                        <Select
                                                            name="tempo_Duracao"
                                                            label="Fechamento"
                                                            disabled={isLoading}
                                                            value={tempoDuracaoLeilao} 
                                                            onChange={(e) => { setTempoDuracaoLeilao(Number(e.target.value)); setAtualizarLeilao(true); }}
                                                            defaultValue={1}>
                                                            {
                                                                terminoLeilao.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                    {/* <SelectComponent
                                                        isExternalLoading={isLoading}
                                                        label="Fechamento"
                                                        name="tempo_Duracao"
                                                        items={terminoLeilao}
                                                        onChange={() => setAtualizarLeilao(true)}
                                                        defaultValue="6"
                                                    /> */}
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 2 }} >
                                                    <TextField
                                                        variant="outlined"
                                                        type="time"
                                                        name="hora_Virada"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={horaViradaLeilao}
                                                        onChange={(e) => setHoraViradaLeilao(e.target.value)}
                                                        label="Hora Virada"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Scope>
                                        <Scope path="liberacoes_Liga" >
                                            <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginTop={1}>
                                                <Grid size={{ xs: 12, sm: 12 }}>
                                                    <Typography variant="h6">Estouro de Limites</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 2 }} display="flex" justifyContent="center">
                                                    <FormControlLabel
                                                        sx={{
                                                            display: 'block',
                                                        }}
                                                        control={
                                                            <Switch
                                                                checked={liberarEncerrar}
                                                                onChange={handleLiberarEncerrarEstouroLimites}
                                                                name="situacao"
                                                                color="primary"
                                                            />
                                                        }
                                                        label={labelLiberarEncerrar}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 2 }} >
                                                    <CheckBox
                                                        name="baixo_Min_Cap"
                                                        isExternalLoading={isLoading}
                                                        checked={capMinimo}
                                                        onChange={e => setCapMinimo(e.target.checked)}
                                                        label="CAP Mínimo"
                                                        labelPlacement="start"
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 2 }} >
                                                    <CheckBox
                                                        name="estouro_Cap"
                                                        isExternalLoading={isLoading}
                                                        checked={capMaximo}
                                                        onChange={e => setCapMaximo(e.target.checked)}
                                                        label="CAP Máximo"
                                                        labelPlacement="start"
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 2 }} >
                                                    <CheckBox
                                                        name="baixo_Min_Jog"
                                                        isExternalLoading={isLoading}
                                                        checked={minJogadores}
                                                        onChange={e => setMinJogadores(e.target.checked)}
                                                        label="Mínimo Jogadores"
                                                        labelPlacement="start"
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 2 }} >
                                                    <CheckBox
                                                        name="estouro_Max_Jog"
                                                        isExternalLoading={isLoading}
                                                        checked={maxJogadores}
                                                        onChange={e => setMaxJogadores(e.target.checked)}
                                                        label="Máximo Jogadores"
                                                        labelPlacement="start"
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 3, md: 2 }} >
                                                    <CheckBox
                                                        name="baixo_Min_Pos"
                                                        isExternalLoading={isLoading}
                                                        checked={minPosicao}
                                                        onChange={e => setMinPosicao(e.target.checked)}
                                                        label="Mínima Posição"
                                                        labelPlacement="start"
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 3 }} marginTop={2}>
                                                    <TextField
                                                        style={{ colorScheme: "auto" }}
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        name="data_Inicio"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={data_Inicio_EL}
                                                        onChange={(e) => setData_Inicio_EL(e.target.value)}
                                                        label="Data Limite Início"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12, md: 3 }} marginTop={2}>
                                                    <TextField
                                                        style={{ colorScheme: "auto" }}
                                                        type="datetime-local"
                                                        variant="outlined"
                                                        name="data_Fim"
                                                        fullWidth
                                                        disabled={isLoading}
                                                        value={data_Encerramento_EL}
                                                        onChange={(e) => setData_Encerramento_EL(e.target.value)}
                                                        label="Data Limite Término"
                                                        slotProps={{
                                                            inputLabel: {
                                                                shrink: true,
                                                            },
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Scope>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={4}>
                                    <Grid container size={{ xs: 12, sm: 12 }} direction="column">
                                        {!removeLoading && <Loading />}
                                        <Scope path="configuracao_Calendario_Liga">
                                            <Grid container size={{ xs: 12, sm: 12 }} direction="column" >
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} >
                                                    <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                        <Typography variant="h6">Play Offs</Typography>
                                                        <hr />
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2} >
                                                    <Grid size={{ xs: 12, sm: 3, md: 2 }} >
                                                        <FormControl fullWidth disabled={isLoading}>
                                                            <InputLabel id="qtd-simple-select-label">{"Melhor De"}</InputLabel>
                                                            <Select
                                                                value={melhorDe}
                                                                variant="outlined"
                                                                label={"Melhor De"}
                                                                onChange={(e) => { setMelhorDe(Number(e.target.value)); }}
                                                                name="quantidade_Rodadas_Play_Offs"
                                                            >
                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                {
                                                                    lstMelhorDe.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                }

                                                            </Select>
                                                        </FormControl >
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 4 }} display="flex">
                                                        <CheckBox
                                                            name="play_In"
                                                            isExternalLoading={isLoading}
                                                            checked={playIn}
                                                            onChange={e => { setPlayIn(e.target.checked); }}
                                                            label="Play IN"
                                                            labelPlacement="start"
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} direction="column" >
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2}>
                                                    <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                        <Typography variant="h6">Regular</Typography>
                                                        <hr />
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2}>
                                                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                                                        <CheckBox
                                                            required
                                                            name="enfrentar_Mais_Vezes_Divisao"
                                                            isExternalLoading={isLoading}
                                                            checked={maisDivisao}
                                                            onChange={e => setMaisDivisao(e.target.checked)}
                                                            label="Enfrentar Mais Vezes Divisão"
                                                            labelPlacement="start"
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 4 }} >
                                                        <CheckBox
                                                            required
                                                            name="enfrentar_Mais_Vezes_Conferencia"
                                                            isExternalLoading={isLoading}
                                                            checked={maisConferencia}
                                                            onChange={e => setMaisConferencia(e.target.checked)}
                                                            label="Enfrentar Mais Vezes Conferência"
                                                            labelPlacement="start"
                                                        />
                                                    </Grid>
                                                    <Grid size={{ xs: 12, sm: 6, md: 4 }} display="none" >
                                                        <CheckBox
                                                            required
                                                            name="all_Star_Game_Liga"
                                                            isExternalLoading={isLoading}
                                                            checked={allStarGameLiga}
                                                            onChange={e => { setAllStarGameLiga(e.target.checked); }}
                                                            label="Criacao All Star Game Liga"
                                                            labelPlacement="start"
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2}>
                                                    <Grid size={{ xs: 12, sm: 6, md: 2 }} >
                                                        <FormControl fullWidth disabled={isLoading}>
                                                            <InputLabel id="qtd-simple-select-label">{"Quantidade Rodadas"}</InputLabel>
                                                            <Select
                                                                value={qtdRodadas}
                                                                variant="outlined"
                                                                label={"Quantidade Rodadas"}
                                                                onChange={(e) => { setQtdRodadas(Number(e.target.value)); setAtualizaCanlendario(true); }}
                                                                name="quantidade_Rodadas"
                                                            >
                                                                <MenuItem value={0}>Selecione</MenuItem>
                                                                {
                                                                    lstQuantidadeRodadas.map(item => (<MenuItem key={item.codigo} value={item.codigo}>{item.label}</MenuItem>))
                                                                }

                                                            </Select>
                                                        </FormControl >
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid container size={{ xs: 12, sm: 12 }} direction="column" display={user.administrador ? "block" : "none"} >
                                                <Grid container size={{ xs: 12, sm: 12 }} spacing={1} display="flex" marginBottom={2}>
                                                    <Grid size={{ xs: 12, sm: 12 }} textAlign="initial" >
                                                        <Typography variant="h6">Rodadas</Typography>
                                                        <hr />
                                                    </Grid>
                                                </Grid>
                                                <Grid size={{ xs: 12, sm: 12 }} alignItems="center" justifyContent="center" width="100%">
                                                    <Grid size={{ xs: 12, sm: 12 }} alignItems="center" justifyContent="center" width="99%">
                                                        <Paper>
                                                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                                                <Tabs value={valueTabRodada}
                                                                    onChange={handleChangeTabsRodadas}
                                                                    variant="scrollable"
                                                                    scrollButtons
                                                                    sx={{
                                                                        [`& .${tabsClasses.scrollButtons}`]: {
                                                                            '&.Mui-disabled': { opacity: 0.3 },
                                                                        },
                                                                    }}
                                                                >
                                                                    {showRodadasTabs && qtdRodadasEscolidas.map((t, i) => (
                                                                        <Tab key={`tab${i}`} label={t} {...a11yProps(i)} />
                                                                    ))
                                                                    }
                                                                </Tabs>
                                                            </Box>
                                                            {qtdRodadasEscolidas.map((q, i) => (
                                                                <TabPanel key={i} value={valueTabRodada} index={i}>
                                                                    {valoresTimeSorteio.filter((f) => f.rodada === q).map((t) => (
                                                                        <Typography>{`${lstFranquia.find(l => l.codigo === t.mandante)?.label} - ${t.mandante} X ${lstFranquia.find(l => l.codigo === t.visitante)?.label} -${t.visitante}`}</Typography>
                                                                    ))
                                                                    }
                                                                </TabPanel>
                                                            ))
                                                            }
                                                        </Paper>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Scope>
                                    </Grid>
                                </TabPanel>
                                <TabPanel value={value} index={5}>
                                    <Grid container size={{ xs: 12, sm: 12 }} spacing={2}>
                                        {(!removeLoading || isLoading) && <Loading />}
                                        <Grid size={{ xs: 12, sm: 12 }} padding={1} >
                                            <Typography variant="h6">Sorteio Grupos</Typography>
                                            <hr />
                                        </Grid>
                                        <Grid container size={{ xs: 12, sm: 12 }} spacing={2}>
                                            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}>
                                                <Button
                                                    color="primary"
                                                    variant="contained"
                                                    disableElevation
                                                    disabled={copinhaSorteada}
                                                    onClick={handleSorteioCopinha}
                                                    startIcon={<Icon>change_circle</Icon>}
                                                >
                                                    Sortear
                                                </Button>
                                            </Grid>
                                            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4, xl: 4 }}
                                                display={copinhaSorteada ? "block" : "none"}
                                            >
                                                <Typography variant="body1" style={{ fontSize: UtilidadeService.isMobile() ? 12 : 16 }}>
                                                    Data Sorteio: {dayjs(dadosLiga?.data_Sorteio_Copinha).format('DD/MM/YYYY HH:mm')}
                                                </Typography>

                                            </Grid>
                                        </Grid>
                                        {copinhaSorteada && (
                                            <>
                                                <Grid size={{ xs: 12, sm: 12 }} paddingTop={1} >
                                                    <Typography variant="h6">Grupos</Typography>
                                                    <hr />
                                                </Grid>
                                                <Grid container size={{ xs: 12, sm: 12 }} display="flex">
                                                    <Grid container size={{ xs: 12, sm: 12 }} display={"flex"} spacing={1} >
                                                        {dadosCopinha?.grupos.map(g => (
                                                            <Grid container size={{ xs: 12, sm: 6 }}  >
                                                                <Grid container size={{ xs: 12, sm: 12 }} >
                                                                    <Grid size={{ xs: 12, sm: 12 }} padding={1}><Typography variant="h6">{g.nome}</Typography></Grid>
                                                                    <Grid size={{ xs: 12, sm: 12 }} >
                                                                        <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                                                                            <Table>
                                                                                <TableHead>
                                                                                    <StyledTableRow>
                                                                                        {/* <StyledTableCell width={100}>Ações</StyledTableCell> */}
                                                                                        <StyledTableCell width={100} align="center">LOGO</StyledTableCell>
                                                                                        {/* <StyledTableCell>CÓDIGO</StyledTableCell> */}
                                                                                        <StyledTableCell >FRANQUIA</StyledTableCell>
                                                                                    </StyledTableRow>
                                                                                </TableHead>
                                                                                <TableBody>
                                                                                    {g.franquias.map((row, index) => (
                                                                                        <StyledTableRow key={index}>
                                                                                            <StyledTableCell align="center">{<img src={row.caminho_Logo} width={UtilidadeService.isMobile() ? 20 : 40} height={UtilidadeService.isMobile() ? 20 : 40} />}</StyledTableCell>
                                                                                            {/* <StyledTableCell>{row.codigo}</StyledTableCell> */}
                                                                                            <StyledTableCell >{row.nome}</StyledTableCell>
                                                                                        </StyledTableRow>
                                                                                    ))
                                                                                    }
                                                                                </TableBody>
                                                                                <TableFooter>
                                                                                    {isLoading && (
                                                                                        <StyledTableRow>
                                                                                            <StyledTableCell colSpan={5}>
                                                                                                <LinearProgress variant="indeterminate" />
                                                                                            </StyledTableCell>
                                                                                        </StyledTableRow>
                                                                                    )}
                                                                                </TableFooter>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                </Grid>
                                            </>
                                        )}
                                    </Grid>
                                </TabPanel>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
            </VForm>
        </LayoutBaseDePagina >
    );
};